// import React, { useState, useEffect, useRef, useCallback } from "react";
// import Modal from "./Modal";
// import Refine from "./refine";
// import References from "./References";
// import Doc from "./documentselector";
// import loadingGif from "../assest/Loading.gif";
// import ReactMarkdown from "react-markdown";
// import remarkGfm from "remark-gfm";
// import Header from "../components/Header.js";
// import ScrollButton from "./ScrollButton";
// import rehypeRaw from 'rehype-raw';
// import CharacterDisplay from "./CharacterDisplay.jsx";
// import nerdyicon from "../assest/logo2.png";
// import { useTranslation } from "react-i18next";
// import { useNavigate } from "react-router-dom";
// import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
// import axios from "axios";
// import { logout } from "../features/auth/authSlice.js";
// import { useDispatch } from "react-redux";
// import LiveChat from "../components/LiveChat.jsx";

// const Home = ({ dir }) => {

//   const navigate = useNavigate();
//   const { t } = useTranslation();
//   const dispatch = useDispatch();

//   const chatContainerRef = useRef(null);
//   const streamBufferRef = useRef("");
//   const streamFlushTimerRef = useRef(null);

//   const [question, setQuestion] = useState("");
//   const [currentQuestion, setCurrentQuestion] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [conversation, setConversation] = useState([]);
//   const [references, setReferences] = useState("");
//   const [suggestedQuestions, setSuggestedQuestions] = useState([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [modalType, setModalType] = useState("");
//   const [responseStream, setResponseStream] = useState("");
//   const [helperButton, setHelperButton] = useState(false);
//   const [helperLoader, setHelperLoader] = useState(false);
//   const [refineCount] = useState(0);
//   const [documentCount, setDocumentCount] = useState(0);
//   const [sessionNumber, setSessionNumber] = useState(null);
//   const [latestSession, setLatestSession] = useState();
//   const [currentSessionId, setCurrentSessionId] = useState(null);
//   const [documentInfo, setDocumentInfo] = useState([]);
//   const [userSession, setUserSession] = useState([]);

//   const startListening = () => SpeechRecognition.startListening({ continuous: true, language: 'en-US', interimResults: true });
//   const { transcript, listening, resetTranscript, browserSupportsSpeechRecognition } = useSpeechRecognition();
//   const [permission, setPermission] = useState('prompt');

//   // ── Edit message state ──────────────────────────────────────────────────────
//   const [editingMessageId, setEditingMessageId] = useState(null);
//   const [editingText, setEditingText] = useState("");

//   const streamAbortControllerRef = useRef(null);

//   const storedData = localStorage.getItem("profileData") || sessionStorage.getItem("profileData");
//   let parsedDataOutScope;

//   if (storedData) {
//     const parsedData = JSON.parse(storedData);
//     parsedDataOutScope = parsedData;
//   }

//   const isDev = process.env.NODE_ENV === 'development';

//   const handleSignout = useCallback(() => {

//     localStorage.removeItem("user");
//     localStorage.removeItem("token");
//     localStorage.removeItem("profileData");

//     sessionStorage.removeItem("user");
//     sessionStorage.removeItem("token");
//     sessionStorage.removeItem("profileData");

//     sessionStorage.removeItem("conversation");
//     sessionStorage.removeItem("currentSessionId");
//     sessionStorage.removeItem("sessionNumber");
//     sessionStorage.removeItem("sessions");

//     dispatch(logout())
//     navigate("/login");

//   }, [navigate, dispatch]);

//   const hitRatingApi = async (ratingType, lastQuestion, thisResponse, referenceDoc) => {

//     const response = await fetch(
//       `${process.env.REACT_APP_PORTAL_APP_BASE_URL}/admin/support/rating`,
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           token: `${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
//         },
//         body: JSON.stringify({
//           RatingType: ratingType,
//           question: lastQuestion,
//           answer: thisResponse,
//           documentFileNames: referenceDoc,
//         }),
//       }
//     );
//     console.log(response);
//   }

//   const fetchSessions = useCallback(async () => {
//     try {
//       const baseUrl = process.env.REACT_APP_BASEURL;
//       const token = localStorage.getItem("token") || sessionStorage.getItem("token");

//       if (!token) {

//         localStorage.removeItem("user");
//         localStorage.removeItem("token");
//         localStorage.removeItem("profileData");

//         sessionStorage.removeItem("user");
//         sessionStorage.removeItem("token");
//         sessionStorage.removeItem("profileData");

//         sessionStorage.removeItem("conversation");
//         sessionStorage.removeItem("currentSessionId");
//         sessionStorage.removeItem("sessionNumber");
//         sessionStorage.removeItem("sessions");

//         dispatch(logout())
//         navigate("/login");

//       }

//       const response = await axios.get(`${baseUrl}/get_user_sessions`, {
//         headers: {
//           "Content-Type": "application/json",
//           "Authorization": `Bearer ${token}`,
//         },
//       });

//       const data = response.data;
//       const apiResponse = {
//         sessionIds: data?.sessions?.map(session => session.sessionId)
//       };

//       console.log(apiResponse, "Transformed API Response");
//       setUserSession(apiResponse);
//       return apiResponse;
//     } catch (err) {
//       if (err?.response?.status === 401) {
//         handleSignout();
//       }
//       console.log("Failed to fetch sessions:", err);
//       return [];
//     }
//   }, [navigate, dispatch, handleSignout]);

//   const getNextAvailableSessionId = (existingSessionIds) => {
//     let i = 1;
//     let newId;
//     do {
//       newId = `Session-${i}`;
//       i++;
//     } while (existingSessionIds.includes(newId));
//     return newId;
//   };

//   useEffect(() => {
//     // Only update the sessionStorage if we have a valid current session ID
//     if (currentSessionId && conversation.length > 0) {
//       const savedSessions = JSON.parse(sessionStorage.getItem("sessions")) || [];

//       // Find the index of the current session in the array
//       const sessionIndex = savedSessions.findIndex(session => session.id === currentSessionId);

//       if (sessionIndex >= 0) {
//         // Update the existing session
//         savedSessions[sessionIndex] = {
//           ...savedSessions[sessionIndex],
//           conversation
//         };
//       } else {
//         // Add a new session
//         savedSessions.push({
//           id: currentSessionId,
//           name: latestSession || `Session ${sessionNumber}`,
//           date: new Date().toLocaleString(),
//           conversation
//         });
//       }
//       sessionStorage.setItem("sessions", JSON.stringify(savedSessions));
//       sessionStorage.setItem("conversation", JSON.stringify(conversation));
//     }
//   }, [conversation, currentSessionId, latestSession, sessionNumber]);

//   const handleStream = async () => {

//     if (!question.trim()) return;

//     setDocumentInfo([]);
//     setCurrentQuestion(question);
//     setResponseStream("");
//     setHelperButton(false);
//     setLoading(true);

//     const newUserMessage = {
//       id: `user-${Date.now()}`,
//       sender: "user",
//       message: question,
//     };

//     setConversation((prev) => [...prev, newUserMessage]);

//     try {

//       console.log("check hit open:")
//       const controller = new AbortController();
//       streamAbortControllerRef.current = controller;
//       const responseStream = await fetch(
//         `${process.env.REACT_APP_BASEURL}/stream_response`,

//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
//           },
//           signal: controller.signal,
//           body: JSON.stringify({
//             query: question,
//             chat_history: conversation.map((msg) => msg.message),
//             language: "en",
//             session_id: currentSessionId,
//           }),
//         }
//       );

//       console.log("check hit close: ", responseStream)

//       if (!responseStream.ok) {
//         throw new Error(
//           `Server responded with status ${responseStream.status}`
//         );
//       }

//       const reader = responseStream.body.getReader();
//       const decoder = new TextDecoder();
//       let done = false;
//       let accumulatedResponse = "";
//       let displayedResponse = "";

//       // Create a buffer to hold partial content that might include special sections
//       let buffer = "";
//       const referencePattern = /\*\*References:\*\*([\s\S]*?)(?=\n\*\*|$)/;
//       const followUpPattern = /\*\*followUp:\*\*([\s\S]*?)(?:$)/;
//       const tableHeaderPattern = /\|\s*\*\*Document Name\*\*\s*\|\s*\*\*Section Name\*\*\s*\|\s*\*\*Section Number\*\*\s*\|/;
//       const tableRowPattern = /\|[^|]*\|[^|]*\|[^|]*\|/g;

//       // Multiple question patterns to catch different formats
//       const questionPatterns = [
//         /\*\* Question:[\s\S]*?(?=\*\*|\n\n|$)/g,     // Format: ** Question:
//         /\*\*Question:[\s\S]*?(?=\*\*|\n\n|$)/g,      // Format: **Question:
//         /\*\*\s*Question:[\s\S]*?(?=\*\*|\n\n|$)/g,   // Format with varying spaces
//         /\*\* Question: What would[\s\S]*?(?=\*\*|\n\n|$)/g, // Specific pattern with content
//         /\*\* Question[\s\S]*?(?:Something else entirely|$)/g, // Most generic pattern
//         /\*\*[\s\S]*?Question:[\s\S]*?(?:Something else|$)/g,  // Super generic pattern
//         /\*\*Referenced Files Metadata:[\s\S]*?(?=\*\*Referenced Files:|$)/g,
//         /\*\*Referenced Files:\*\*[\s\S]*/g
//       ];

//       while (!done) {
//         const { value, done: streamDone } = await reader.read();
//         done = streamDone;

//         if (value) {
//           const chunk = decoder.decode(value, { stream: true });

//           // Add to accumulated response for later processing
//           accumulatedResponse += chunk;

//           // Add to buffer for filtering
//           buffer += chunk;

//           // Check if buffer contains any special sections to remove
//           let cleanBuffer = buffer;

//           // Remove any references section
//           const refMatch = cleanBuffer.match(referencePattern);
//           if (refMatch) {
//             cleanBuffer = cleanBuffer.replace(referencePattern, "");
//           }

//           // Remove any followUp section
//           const followUpMatch = cleanBuffer.match(followUpPattern);
//           if (followUpMatch) {
//             cleanBuffer = cleanBuffer.replace(followUpPattern, "");
//           }

//           // Check for document tables
//           if (cleanBuffer.includes("Document Name") || cleanBuffer.match(tableHeaderPattern)) {
//             // Remove entire table header row
//             cleanBuffer = cleanBuffer.replace(tableHeaderPattern, "");

//             // Remove any table rows
//             cleanBuffer = cleanBuffer.replace(tableRowPattern, "");
//           }

//           // Remove question sections with options - try all patterns
//           for (const pattern of questionPatterns) {
//             cleanBuffer = cleanBuffer.replace(pattern, "");
//           }

//           // Look for question section keywords without regex for additional filtering
//           if (cleanBuffer.includes("** Question:") || cleanBuffer.includes("**Question:")) {
//             // Additional keyword-based removal
//             const lines = cleanBuffer.split('\n');
//             const filteredLines = lines.filter(line =>
//               !line.includes("Question:") &&
//               !line.includes("Requesting transportation") &&
//               !line.includes("Scheduling a shuttle") &&
//               !line.includes("Understanding itinerary") &&
//               !line.includes("Something else") &&
//               !line.includes("**Referenced Files Metadata:**") &&
//               !line.includes("**Referenced Files:**")
//             );
//             cleanBuffer = filteredLines.join('\n');
//           }

//           // Update displayed response - only show parts we're sure are clean
//           // Keep buffer size reasonable by only keeping potential partial sections
//           if (cleanBuffer.length > 100) {
//             // Add most of the clean buffer to displayed response
//             const addToDisplay = cleanBuffer.slice(0, cleanBuffer.length - 50);
//             displayedResponse += addToDisplay;
//             console.log(displayedResponse, "displayedResponse");
//             // setResponseStream(displayedResponse);
//             // Keep only the last part in the buffer for continued checking
//             streamBufferRef.current = displayedResponse;
//             if (!streamFlushTimerRef.current) {
//               streamFlushTimerRef.current = setTimeout(() => {
//                 setResponseStream(streamBufferRef.current);
//                 streamFlushTimerRef.current = null;
//               }, 32);
//             }
//             buffer = cleanBuffer.slice(cleanBuffer.length - 50);
//           }

//           setLoading(false);
//           setQuestion("");
//         }
//       }

//       // Process the full complete response for extraction
//       const formattedResponse = accumulatedResponse
//         .replace(/answer:\s*/gi, "")
//         .trim();

//       // Extract references, suggested questions, and document details from the response
//       let extractedReferences = "";
//       let extractedSuggestedQuestions = [];
//       let extractedDocumentDetails = [];

//       // Look for References section in the response
//       if (formattedResponse.includes("**References:**") || formattedResponse.includes("References:")) {
//         const referencesMatch = formattedResponse.match(referencePattern);
//         if (referencesMatch && referencesMatch[1]) {
//           extractedReferences = "**References:**" + referencesMatch[1].trim();
//         }
//       }

//       // Look for followUp section for suggested questions
//       if (formattedResponse.includes("**followUp:**") || formattedResponse.includes("followUp:")) {
//         const followUpMatch = formattedResponse.match(followUpPattern);
//         if (followUpMatch && followUpMatch[1]) {
//           let followUpContent = followUpMatch[1].trim();
//           // Clean out any referenced file sections
//           followUpContent = followUpContent
//             .replace(/\*\*Referenced Files Metadata:\*\*[\s\S]*?(?=\*\*Referenced Files:|$)/g, "")
//             .replace(/\*\*Referenced Files:\*\*[\s\S]*/g, "")
//             .trim();

//           // Extract the main question
//           const questionMatch = followUpContent.match(
//             /Question:(.*?)(?:\d\.|\n\n|$)/s
//           );
//           const mainQuestion = questionMatch ? questionMatch[1].trim() : "";

//           // Extract the numbered options
//           const optionsMatches = followUpContent.matchAll(
//             /(\d+)\.\s+(.*?)(?=\d+\.|$)/gs
//           );
//           const options = Array.from(optionsMatches, (match) =>
//             match[2].trim()
//           );

//           if (mainQuestion && options.length > 0) {
//             extractedSuggestedQuestions = [
//               {
//                 question: mainQuestion,
//                 options: options,
//               },
//             ];
//           }
//         }
//       }

//       const referencedFilesPattern = /\*\*Referenced Files:\*\*([\s\S]*?)(?:\n\n|\*\*|$)/;
//       const referencedFilesMatch = formattedResponse.match(referencedFilesPattern);

//       if (referencedFilesMatch && referencedFilesMatch[1]) {
//         const referencedFileEntries = referencedFilesMatch[1]
//           .split("~")
//           .map((entry) => entry.trim())
//           .filter(Boolean);

//         // const extractedDocumentDetails = [];
//         console.log(referencedFileEntries);

//         referencedFileEntries
//           .flatMap(entry => entry.split(/,(?=\s*[^:]+?\.(pdf|docx?|docs)\s*:)/i)) // Split correctly by comma + lookahead
//           .forEach((entry) => {
//             const match = entry.match(/^([\w\s\-()[\]@#&',.]+?\.(pdf|docx?|docs))\s*:\s*([\d.]+)$/i);
//             if (match) {
//               const fileName = match[1].trim();
//               const fileScore = parseFloat(match[3]);
//               // extractedDocumentDetails.push({ fileName, score: fileScore });
//               extractedDocumentDetails.push(fileName);
//               const encodedName = encodeURIComponent(fileName);
//               console.log(fileName, "→ check Documents inside the regex");
//               console.log(encodedName, "→ Document name in PDF");
//               fetch(`${process.env.REACT_APP_PORTAL_APP_BASE_URL}/admin/documents/getDocumentName?search=${encodedName}`, {
//                 method: "GET",
//                 headers: {
//                   "Content-Type": "application/json",
//                   token: `${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
//                 },
//               })
//                 .then((res) => {
//                   if (!res.ok) {
//                     throw new Error(`API failed for document: ${fileName}`);
//                   }
//                   return res.json();
//                 })
//                 .then((data) => {
//                   console.log("API result for", fileName, "→", data);
//                   setDocumentInfo((prev) => [...prev, { documentName: fileName, score: fileScore, data }]);
//                   setDocumentCount(extractedDocumentDetails.length);
//                   if (extractedDocumentDetails.length > 0) {
//                     setHelperButton(true);
//                   }
//                 })
//                 .catch((err) => {
//                   console.error("Error fetching document info:", err);
//                 });
//             }
//           });
//       }

//       // Clean the full response one more time to ensure all special sections are removed
//       let cleanedFullResponse = formattedResponse;
//       cleanedFullResponse = cleanedFullResponse.replace(referencePattern, "");
//       cleanedFullResponse = cleanedFullResponse.replace(followUpPattern, "");
//       cleanedFullResponse = cleanedFullResponse.replace(/\*\*Referenced Files Metadata:\*\*[\s\S]*?(?=\*\*|$)/g, "");

//       // Remove all possible question patterns
//       for (const pattern of questionPatterns) {
//         cleanedFullResponse = cleanedFullResponse.replace(pattern, "");
//       }

//       // Second pass using line-by-line filtering to catch any remaining question sections
//       const lines = cleanedFullResponse.split('\n');
//       const filteredLines = lines.filter(line =>
//         !line.includes("** Question:") &&
//         !line.includes("**Question:") &&
//         !line.includes("Requesting transportation") &&
//         !line.includes("Scheduling a shuttle") &&
//         !line.includes("Understanding itinerary") &&
//         !line.includes("Something else") &&
//         !line.includes("**Referenced Files Metadata:**") &&
//         !line.includes("**Referenced Files:**")
//       );

//       cleanedFullResponse = filteredLines.join('\n');

//       // Remove document tables
//       if (cleanedFullResponse.includes("Document Name")) {
//         const tableLines = cleanedFullResponse.split("\n");
//         const cleanedLines = tableLines.filter(line =>
//           !line.includes("Document Name") &&
//           !line.match(/\|[^|]*\|[^|]*\|[^|]*\|/)
//         );
//         cleanedFullResponse = cleanedLines.join("\n");
//       }

//       // Final cleanup and trim
//       cleanedFullResponse = cleanedFullResponse.trim();
//       // Allow time for new message to render
//       setTimeout(() => {
//         if (chatContainerRef.current) {
//           chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
//         }
//       }, 100);
//       // Set the extracted data
//       setReferences(extractedReferences || "No references found.");
//       setSuggestedQuestions(extractedSuggestedQuestions);
//       setDocumentCount(extractedDocumentDetails.length);

//       console.log(extractedReferences, "extractedReferences check on handlestream");
//       // Show helper buttons if we have any of these features
//       if (
//         extractedReferences ||
//         extractedSuggestedQuestions.length > 0 ||
//         extractedDocumentDetails.length > 0
//       ) {
//         setHelperButton(true);
//       }

//       const newAiMessage = {
//         id: `ai-${Date.now()}`,
//         sender: "ai",
//         message: cleanedFullResponse,
//         ratingGiven: null // Add a field to track if rating was given
//       };

//       setConversation((prev) => [...prev, newAiMessage]);
//       hitRatingApi("Nothing", question, cleanedFullResponse, extractedDocumentDetails);
//       // Clear the stream display
//       setTimeout(() => {
//         setResponseStream("");
//       }, 50);
//     } catch (error) {
//       if (error.name === 'AbortError') {
//         console.log('Stream aborted');
//       } else {
//         console.error("Error fetching response:", error);
//       }
//     } finally {
//       setLoading(false);
//       setHelperLoader(false);
//       streamAbortControllerRef.current = null;
//       streamBufferRef.current = "";
//       if (streamFlushTimerRef.current) {
//         clearTimeout(streamFlushTimerRef.current);
//         streamFlushTimerRef.current = null;
//       }
//     }
//   };

//   const handleSend = async () => {
//     if (!question.trim()) return;
//     setLoading(true);
//     // Allow time for new message to render
//     setTimeout(() => {
//       if (chatContainerRef.current) {
//         chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
//       }
//     }, 100);
//     try {
//       SpeechRecognition.abortListening();
//       resetTranscript();
//       setQuestion("");
//       await handleStream();
//     } catch (error) {
//       console.error("Error executing API:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleStreamWithQuery = async (queryText, priorConversation) => {
//     setDocumentInfo([]);
//     setCurrentQuestion(queryText);
//     setResponseStream("");
//     setHelperButton(false);
//     setLoading(true);

//     const newUserMessage = {
//       id: `user-${Date.now()}`,
//       sender: "user",
//       message: queryText,
//     };

//     const updatedConversation = [...priorConversation, newUserMessage];
//     setConversation(updatedConversation);

//     try {
//       const controller = new AbortController();
//       streamAbortControllerRef.current = controller;

//       const res = await fetch(`${process.env.REACT_APP_BASEURL}/stream_response`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
//         },
//         signal: controller.signal,
//         body: JSON.stringify({
//           query: queryText,
//           chat_history: priorConversation.map((m) => m.message),
//           language: "en",
//           session_id: currentSessionId,
//         }),
//       });

//       if (!res.ok) throw new Error(`Server responded with status ${res.status}`);

//       const reader = res.body.getReader();
//       const decoder = new TextDecoder();
//       let done = false;
//       let accumulatedResponse = "";
//       let displayedResponse = "";
//       let buffer = "";

//       const referencePattern = /\*\*References:\*\*([\s\S]*?)(?=\n\*\*|$)/;
//       const followUpPattern = /\*\*followUp:\*\*([\s\S]*?)(?:$)/;
//       const tableHeaderPattern = /\|\s*\*\*Document Name\*\*\s*\|\s*\*\*Section Name\*\*\s*\|\s*\*\*Section Number\*\*\s*\|/;
//       const tableRowPattern = /\|[^|]*\|[^|]*\|[^|]*\|/g;
//       const questionPatterns = [
//         /\*\* Question:[\s\S]*?(?=\*\*|\n\n|$)/g,
//         /\*\*Question:[\s\S]*?(?=\*\*|\n\n|$)/g,
//         /\*\*\s*Question:[\s\S]*?(?=\*\*|\n\n|$)/g,
//         /\*\*Referenced Files Metadata:[\s\S]*?(?=\*\*Referenced Files:|$)/g,
//         /\*\*Referenced Files:\*\*[\s\S]*/g,
//       ];

//       while (!done) {
//         const { value, done: streamDone } = await reader.read();
//         done = streamDone;
//         if (value) {
//           const chunk = decoder.decode(value, { stream: true });
//           accumulatedResponse += chunk;
//           buffer += chunk;

//           let cleanBuffer = buffer;
//           cleanBuffer = cleanBuffer.replace(referencePattern, "");
//           cleanBuffer = cleanBuffer.replace(followUpPattern, "");
//           if (cleanBuffer.includes("Document Name") || cleanBuffer.match(tableHeaderPattern)) {
//             cleanBuffer = cleanBuffer.replace(tableHeaderPattern, "");
//             cleanBuffer = cleanBuffer.replace(tableRowPattern, "");
//           }
//           for (const p of questionPatterns) cleanBuffer = cleanBuffer.replace(p, "");

//           if (cleanBuffer.length > 100) {
//             const addToDisplay = cleanBuffer.slice(0, cleanBuffer.length - 50);
//             displayedResponse += addToDisplay;
//             streamBufferRef.current = displayedResponse;
//             if (!streamFlushTimerRef.current) {
//               streamFlushTimerRef.current = setTimeout(() => {
//                 setResponseStream(streamBufferRef.current);
//                 streamFlushTimerRef.current = null;
//               }, 32);
//             }
//             buffer = cleanBuffer.slice(cleanBuffer.length - 50);
//           }
//           setLoading(false);
//           setQuestion("");
//         }
//       }

//       // ── Post-stream extraction (mirrors handleStream) ──────────────────────
//       const formattedResponse = accumulatedResponse.replace(/answer:\s*/gi, "").trim();
//       let extractedReferences = "";
//       let extractedSuggestedQuestions = [];
//       let extractedDocumentDetails = [];

//       const referencesMatch = formattedResponse.match(referencePattern);
//       if (referencesMatch?.[1]) extractedReferences = "**References:**" + referencesMatch[1].trim();

//       const followUpMatch = formattedResponse.match(followUpPattern);
//       if (followUpMatch?.[1]) {
//         let fc = followUpMatch[1].trim()
//           .replace(/\*\*Referenced Files Metadata:\*\*[\s\S]*?(?=\*\*Referenced Files:|$)/g, "")
//           .replace(/\*\*Referenced Files:\*\*[\s\S]*/g, "").trim();
//         const qm = fc.match(/Question:(.*?)(?:\d\.|\n\n|$)/s);
//         const mainQuestion = qm ? qm[1].trim() : "";
//         const options = Array.from(fc.matchAll(/(\d+)\.\s+(.*?)(?=\d+\.|$)/gs), (m) => m[2].trim());
//         if (mainQuestion && options.length > 0)
//           extractedSuggestedQuestions = [{ question: mainQuestion, options }];
//       }

//       const referencedFilesPattern = /\*\*Referenced Files:\*\*([\s\S]*?)(?:\n\n|\*\*|$)/;
//       const rfMatch = formattedResponse.match(referencedFilesPattern);
//       if (rfMatch?.[1]) {
//         rfMatch[1].split("~").map(e => e.trim()).filter(Boolean)
//           .flatMap(e => e.split(/,(?=\s*[^:]+?\.(pdf|docx?|docs)\s*:)/i))
//           .forEach(entry => {
//             const m = entry.match(/^([\w\s\-()[\]@#&',.]+?\.(pdf|docx?|docs))\s*:\s*([\d.]+)$/i);
//             if (m) {
//               const fileName = m[1].trim();
//               const fileScore = parseFloat(m[3]);
//               extractedDocumentDetails.push(fileName);
//               fetch(`${process.env.REACT_APP_PORTAL_APP_BASE_URL}/admin/documents/getDocumentName?search=${encodeURIComponent(fileName)}`, {
//                 headers: { "Content-Type": "application/json", token: `${localStorage.getItem("token") || sessionStorage.getItem("token")}` },
//               }).then(r => r.json())
//                 .then(data => {
//                   setDocumentInfo(prev => [...prev, { documentName: fileName, score: fileScore, data }]);
//                   setDocumentCount(extractedDocumentDetails.length);
//                   if (extractedDocumentDetails.length > 0) setHelperButton(true);
//                 }).catch(console.error);
//             }
//           });
//       }

//       let cleanedFull = formattedResponse
//         .replace(referencePattern, "").replace(followUpPattern, "")
//         .replace(/\*\*Referenced Files Metadata:\*\*[\s\S]*?(?=\*\*|$)/g, "");
//       for (const p of questionPatterns) cleanedFull = cleanedFull.replace(p, "");
//       cleanedFull = cleanedFull.split('\n')
//         .filter(l => !l.includes("** Question:") && !l.includes("**Question:") &&
//           !l.includes("**Referenced Files Metadata:**") && !l.includes("**Referenced Files:**"))
//         .join('\n').trim();

//       setReferences(extractedReferences || "No references found.");
//       setSuggestedQuestions(extractedSuggestedQuestions);
//       setDocumentCount(extractedDocumentDetails.length);
//       if (extractedReferences || extractedSuggestedQuestions.length > 0 || extractedDocumentDetails.length > 0)
//         setHelperButton(true);

//       const newAiMessage = { id: `ai-${Date.now()}`, sender: "ai", message: cleanedFull, ratingGiven: null };
//       setConversation(prev => [...prev, newAiMessage]);
//       hitRatingApi("Nothing", queryText, cleanedFull, extractedDocumentDetails);
//       setTimeout(() => setResponseStream(""), 50);
//       setTimeout(() => {
//         if (chatContainerRef.current)
//           chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
//       }, 100);
//     } catch (error) {
//       if (error.name !== 'AbortError') console.error("Error in handleStreamWithQuery:", error);
//     } finally {
//       setLoading(false);
//       setHelperLoader(false);
//       streamAbortControllerRef.current = null;
//       streamBufferRef.current = "";
//       if (streamFlushTimerRef.current) { clearTimeout(streamFlushTimerRef.current); streamFlushTimerRef.current = null; }
//     }
//   };

//   // ── Edit message handlers ───────────────────────────────────────────────────
//   const handleEditMessage = (msg) => {
//     setEditingMessageId(msg.id);
//     setEditingText(msg.message);
//   };

//   const handleCancelEdit = () => {
//     setEditingMessageId(null);
//     setEditingText("");
//   };

//   const handleSaveEdit = async () => {
//     if (!editingText.trim() || loading) return;

//     const msgIndex = conversation.findIndex((m) => m.id === editingMessageId);
//     if (msgIndex === -1) return;

//     // Truncate conversation up to (not including) the edited message
//     const truncated = conversation.slice(0, msgIndex);

//     setEditingMessageId(null);
//     setEditingText("");
//     setHelperButton(false);
//     setSuggestedQuestions([]);
//     setReferences("");
//     setResponseStream("");

//     await handleStreamWithQuery(editingText, truncated);
//   };

//   const stopStream = async () => {
//     try {
//       if (streamAbortControllerRef.current) {
//         try { streamAbortControllerRef.current.abort(); } catch (e) { /* ignore */ }
//       }
//       await fetch(`${process.env.REACT_APP_BASEURL}/stop_stream?sessionId=${currentSessionId}`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
//         },
//       });
//     } catch (err) {
//       console.error("Error calling stop_stream:", err);
//     } finally {
//       // If there's any partial streamed response visible, append it as the AI message
//       try {
//         if (responseStream && responseStream.trim()) {
//           const newAiMessage = {
//             id: `ai-${Date.now()}`,
//             sender: "ai",
//             message: responseStream.trim(),
//             ratingGiven: null
//           };
//           setConversation((prev) => [...prev, newAiMessage]);
//           // clear the transient stream display to avoid duplicates
//           setResponseStream("");
//         }
//       } catch (e) {
//         console.error('Error appending partial stream to conversation:', e);
//       }

//       setLoading(false);
//       streamAbortControllerRef.current = null;
//     }
//   };

//   const handleNavigateToReferences = () => {
//     setModalType("references");
//     setIsModalOpen(true);
//   };

//   const handleRefineSuggestions = () => {
//     setModalType("refine");
//     setIsModalOpen(true);
//   };

//   const handleEditDoc = () => {
//     setModalType("doc");
//     setIsModalOpen(true);
//   };

//   // Complete replacement for the handleSelectOption function with buffering
//   const handleSelectOption = async (selectedOption) => {

//     let displayedQuestion = selectedOption;
//     if (typeof selectedOption === "object") {
//       displayedQuestion = currentQuestion;
//       selectedOption =
//         currentQuestion + " in " + selectedOption.documentName + "?";
//     }

//     console.log(selectedOption, "final selectedOption");
//     setCurrentQuestion(displayedQuestion);
//     setLoading(true);
//     setIsModalOpen(false);
//     setResponseStream(null);
//     setSuggestedQuestions([]);
//     setHelperLoader(true);
//     setHelperButton(true);

//     const newUserMessage = {
//       id: `user-${Date.now()}`,
//       sender: "user",
//       message: selectedOption,
//     };

//     setConversation((prev) => [...prev, newUserMessage]);

//     try {
//       const baseUrl = process.env.REACT_APP_BASEURL;
//       const payload = {
//         query: selectedOption,
//         chat_history: conversation.map((msg) => msg.message),
//         language: "en",
//         session_id: currentSessionId,
//       };

//       const controller = new AbortController();
//       streamAbortControllerRef.current = controller;
//       const streamResponse = await fetch(`${baseUrl}/stream_response`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
//         },
//         signal: controller.signal,
//         body: JSON.stringify(payload),
//       });

//       if (!streamResponse.ok) {
//         throw new Error(`Stream API error: ${streamResponse.status}`);
//       }

//       const reader = streamResponse.body.getReader();
//       const decoder = new TextDecoder();
//       let done = false;
//       let fullStreamData = "";
//       let displayedResponse = "";
//       console.log(reader, "displayedResponse");

//       // Create a buffer to hold partial content that might include special sections
//       let buffer = "";
//       const referencePattern = /\*\*References:\*\*([\s\S]*?)(?:\*\*followUp:|$)/;
//       const followUpPattern = /\*\*followUp:\*\*([\s\S]*?)(?:$)/;
//       const tableHeaderPattern = /\|\s*\*\*Document Name\*\*\s*\|\s*\*\*Section Name\*\*\s*\|\s*\*\*Section Number\*\*\s*\|/;
//       const tableRowPattern = /\|[^|]*\|[^|]*\|[^|]*\|/g;

//       // Multiple question patterns to catch different formats
//       const questionPatterns = [
//         /\*\* Question:[\s\S]*?(?=\*\*|\n\n|$)/g,     // Format: ** Question:
//         /\*\*Question:[\s\S]*?(?=\*\*|\n\n|$)/g,      // Format: **Question:
//         /\*\*\s*Question:[\s\S]*?(?=\*\*|\n\n|$)/g,   // Format with varying spaces
//         /\*\* Question: What would[\s\S]*?(?=\*\*|\n\n|$)/g, // Specific pattern with content
//         /\*\* Question[\s\S]*?(?:Something else entirely|$)/g, // Most generic pattern
//         /\*\*[\s\S]*?Question:[\s\S]*?(?:Something else|$)/g,  // Super generic pattern
//         /\*\*Referenced Files Metadata:[\s\S]*?(?=\*\*Referenced Files:|$)/g,
//         /\*\*Referenced Files:\*\*[\s\S]*/g
//       ];

//       while (!done) {
//         const { value, done: streamDone } = await reader.read();
//         done = streamDone;

//         if (value) {
//           const chunk = decoder.decode(value, { stream: true });

//           // Add to full stream data for later processing
//           fullStreamData += chunk;

//           // Add to buffer for filtering
//           buffer += chunk;

//           // Check if buffer contains any special sections to remove
//           let cleanBuffer = buffer;

//           // Remove any references section
//           const refMatch = cleanBuffer.match(referencePattern);
//           if (refMatch) {
//             cleanBuffer = cleanBuffer.replace(referencePattern, "");
//           }

//           // Remove any followUp section
//           const followUpMatch = cleanBuffer.match(followUpPattern);
//           if (followUpMatch) {
//             cleanBuffer = cleanBuffer.replace(followUpPattern, "");
//           }

//           // Check for document tables
//           if (cleanBuffer.includes("Document Name") || cleanBuffer.match(tableHeaderPattern)) {
//             // Remove entire table header row
//             cleanBuffer = cleanBuffer.replace(tableHeaderPattern, "");

//             // Remove any table rows
//             cleanBuffer = cleanBuffer.replace(tableRowPattern, "");
//           }

//           // Remove question sections with options - try all patterns
//           for (const pattern of questionPatterns) {
//             cleanBuffer = cleanBuffer.replace(pattern, "");
//           }

//           // Look for question section keywords without regex for additional filtering
//           if (cleanBuffer.includes("** Question:") || cleanBuffer.includes("**Question:")) {
//             // Additional keyword-based removal
//             const lines = cleanBuffer.split('\n');
//             const filteredLines = lines.filter(line =>
//               !line.includes("Question:") &&
//               !line.includes("Requesting transportation") &&
//               !line.includes("Scheduling a shuttle") &&
//               !line.includes("Understanding itinerary") &&
//               !line.includes("Something else") &&
//               !line.includes("**Referenced Files Metadata:**") &&
//               !line.includes("**Referenced Files:**")
//             );
//             cleanBuffer = filteredLines.join('\n');
//           }

//           // Update displayed response - only show parts we're sure are clean
//           // Keep buffer size reasonable by only keeping potential partial sections
//           if (cleanBuffer.length > 100) {
//             // Add most of the clean buffer to displayed response
//             const addToDisplay = cleanBuffer.slice(0, cleanBuffer.length - 50);
//             displayedResponse += addToDisplay;
//             // setResponseStream(displayedResponse);
//             streamBufferRef.current = displayedResponse;
//             if (!streamFlushTimerRef.current) {
//               streamFlushTimerRef.current = setTimeout(() => {
//                 setResponseStream(streamBufferRef.current);
//                 streamFlushTimerRef.current = null;
//               }, 32);
//             }

//             // Keep only the last part in the buffer for continued checking
//             buffer = cleanBuffer.slice(cleanBuffer.length - 50);
//           }
//           setLoading(false);
//         }
//       }

//       // Process the full complete response for extraction
//       // Extract references, suggested questions, and document details from the response
//       let extractedReferences = "";
//       let extractedSuggestedQuestions = [];
//       let extractedDocumentDetails = [];

//       // Clean the full response one more time to ensure all special sections are removed
//       let cleanedFullResponse = fullStreamData;

//       // Look for References section in the response
//       if (fullStreamData.includes("**References:**") || fullStreamData.includes("References:")) {
//         const referencesMatch = fullStreamData.match(referencePattern);
//         if (referencesMatch && referencesMatch[1]) {
//           extractedReferences = "**References:**" + referencesMatch[1].trim();
//           // Remove references section from the clean response
//           cleanedFullResponse = cleanedFullResponse.replace(referencePattern, "");
//         }
//       }

//       // Look for followUp section for suggested questions
//       if (fullStreamData.includes("**followUp:**") || fullStreamData.includes("followUp:")) {
//         const followUpMatch = fullStreamData.match(followUpPattern);
//         if (followUpMatch && followUpMatch[1]) {
//           let followUpContent = followUpMatch[1].trim();
//           // Clean out any referenced file sections
//           followUpContent = followUpContent
//             .replace(/\*\*Referenced Files Metadata:\*\*[\s\S]*?(?=\*\*Referenced Files:|$)/g, "")
//             .replace(/\*\*Referenced Files:\*\*[\s\S]*/g, "")
//             .trim();

//           // Extract the main question
//           const questionMatch = followUpContent.match(
//             /Question:(.*?)(?:\d\.|\n\n|$)/s
//           );
//           const mainQuestion = questionMatch ? questionMatch[1].trim() : "";

//           // Extract the numbered options
//           const optionsMatches = followUpContent.matchAll(
//             /(\d+)\.\s+(.*?)(?=\d+\.|$)/gs
//           );
//           const options = Array.from(optionsMatches, (match) =>
//             match[2].trim()
//           );

//           if (mainQuestion && options.length > 0) {
//             extractedSuggestedQuestions = [
//               {
//                 question: mainQuestion,
//                 options: options,
//               },
//             ];
//           }
//           // Remove followUp section from the clean response
//           cleanedFullResponse = cleanedFullResponse.replace(followUpPattern, "");
//           cleanedFullResponse = cleanedFullResponse.replace(/\*\*Files Metadata:\*\*[\s\S]*?(?=\*\*|$)/g, "");
//         }
//       }

//       // Look for document details in the response
//       if (fullStreamData.includes("Document Name")) {
//         // Remove document tables from clean response
//         cleanedFullResponse = cleanedFullResponse.replace(tableHeaderPattern, "");
//         cleanedFullResponse = cleanedFullResponse.replace(tableRowPattern, "");

//         const lines = fullStreamData.split("\n");

//         for (let i = 0; i < lines.length; i++) {
//           if (
//             lines[i].includes("Document Name") &&
//             lines[i].includes("Section Name")
//           ) {
//             // The table header is at index i, so data should start at i+1
//             if (i + 1 < lines.length && lines[i + 1].includes("|")) {
//               // This seems to be a table row
//               const docDetailsLine = `file_name:${lines[i + 1].split("|")[1].trim()}, creation_date:${new Date().toISOString().split("T")[0]}`;
//               extractedDocumentDetails.push(docDetailsLine);
//             }
//           }
//         }
//       }

//       // Remove all possible question patterns
//       for (const pattern of questionPatterns) {
//         cleanedFullResponse = cleanedFullResponse.replace(pattern, "");
//       }

//       // Second pass using line-by-line filtering to catch any remaining question sections
//       const lines = cleanedFullResponse.split('\n');
//       const filteredLines = lines.filter(line =>
//         !line.includes("** Question:") &&
//         !line.includes("**Question:") &&
//         !line.includes("Requesting transportation") &&
//         !line.includes("Scheduling a shuttle") &&
//         !line.includes("Understanding itinerary") &&
//         !line.includes("Something else") &&
//         !line.includes("**Referenced Files Metadata:**") &&
//         !line.includes("**Referenced Files:**")
//       );

//       cleanedFullResponse = filteredLines.join('\n');

//       // Final cleanup and trim
//       cleanedFullResponse = cleanedFullResponse.trim();

//       // Set the extracted data
//       setReferences(extractedReferences || "No references found.");
//       setSuggestedQuestions(extractedSuggestedQuestions);
//       setDocumentCount(extractedDocumentDetails.length);

//       // Show helper buttons if we have any of these features
//       if (
//         extractedReferences ||
//         extractedSuggestedQuestions.length > 0 ||
//         extractedDocumentDetails.length > 0
//       ) {
//         setHelperButton(true);
//       }


//       const newAiMessage = {
//         id: `ai-${Date.now()}`,
//         sender: "ai",
//         message: cleanedFullResponse,
//         ratingGiven: null // Add a field to track if rating was given
//       };

//       setConversation((prev) => [...prev, newAiMessage]);
//       setHelperLoader(false);
//       hitRatingApi("Nothing", question, cleanedFullResponse, extractedDocumentDetails);
//       // Clear response stream to avoid duplication
//       setTimeout(() => {
//         setResponseStream("");
//       }, 50);
//     } catch (error) {
//       if (error.name === 'AbortError') {
//         console.log('Stream aborted (select option)');
//       } else {
//         console.error("Error fetching response:", error);
//       }
//     } finally {
//       setLoading(false);
//       setHelperLoader(false);
//       streamAbortControllerRef.current = null;
//       streamBufferRef.current = "";
//       if (streamFlushTimerRef.current) {
//         clearTimeout(streamFlushTimerRef.current);
//         streamFlushTimerRef.current = null;
//       }
//     }
//   };

//   // Function to handle rating submissions
//   const handleRating = async (messageId, ratingType) => {
//     try {
//       // Find the last question and this response
//       const messageIndex = conversation.findIndex(
//         (msg) => msg.id === messageId
//       );
//       if (messageIndex <= 0) return; // Safety check

//       // Get the last question (should be right before this response)
//       const lastQuestion = conversation[messageIndex - 1].message;
//       const thisResponse = conversation[messageIndex].message;

//       const response = await fetch(
//         `${process.env.REACT_APP_PORTAL_APP_BASE_URL}/admin/support/rating`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             token: `${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
//           },
//           body: JSON.stringify({
//             RatingType: ratingType,
//             question: lastQuestion,
//             answer: thisResponse,
//           }),
//         }
//       );

//       if (!response.ok) {
//         throw new Error(`Server responded with status ${response.status}`);
//       }

//       // Update conversation to mark the message as rated
//       setConversation((prev) =>
//         prev.map((msg) =>
//           msg.id === messageId ? { ...msg, ratingGiven: ratingType } : msg
//         )
//       );
//     } catch (error) {
//       console.error("Error submitting rating:", error);
//     }
//   };

//   const handleNewSession = useCallback(async () => {
//     sessionStorage.removeItem("conversation");
//     sessionStorage.removeItem("currentSessionId");
//     sessionStorage.removeItem("sessionNumber");

//     try {
//       const latestSessions = await fetchSessions();
//       const existingSessionIds = latestSessions.sessionIds || [];
//       const newSessionId = getNextAvailableSessionId(existingSessionIds);

//       const firstUserMessage = conversation.find(msg => msg.sender === "user");
//       const sessionName = firstUserMessage
//         ? (firstUserMessage.message.length > 30
//           ? firstUserMessage.message.substring(0, 30) + "..."
//           : firstUserMessage.message)
//         : `${newSessionId}`;

//       const newSession = {
//         id: newSessionId,
//         name: sessionName,
//         date: new Date().toLocaleString(),
//         conversation,
//       };

//       const updatedSessions = [newSession];
//       setLatestSession(newSessionId);
//       setCurrentSessionId(newSessionId);

//       setConversation([]);

//       sessionStorage.setItem("sessions", JSON.stringify(updatedSessions));
//       sessionStorage.setItem("conversation", JSON.stringify([]));
//       sessionStorage.setItem("sessionNumber", newSessionId);

//       // Reset helper state
//       setHelperButton(false);
//       setSuggestedQuestions([]);
//       setReferences("");
//       setResponseStream("");
//       setCurrentQuestion("");
//       setEditingMessageId(null);
//       setEditingText("");

//     } catch (error) {
//       console.error("Failed to handle new session:", error);
//     }
//   }, [
//     conversation,
//     setLatestSession,
//     setCurrentSessionId,
//     setConversation,
//     setHelperButton,
//     setSuggestedQuestions,
//     setReferences,
//     setResponseStream,
//     setCurrentQuestion,
//     fetchSessions
//   ]);

//   useEffect(() => {
//     const savedConversation = sessionStorage.getItem("conversation");
//     const savedSessionId = sessionStorage.getItem("sessionNumber");

//     if (savedConversation && savedSessionId) {
//       console.log(savedSessionId, "savedSessionId");

//       const parsedConversation = JSON.parse(savedConversation);
//       setConversation(parsedConversation);
//       setCurrentSessionId(savedSessionId);
//       setLatestSession(savedSessionId);

//       setTimeout(() => {
//         if (chatContainerRef.current) {
//           chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
//         }
//       }, 100);
//     } else {
//       const existingSessionIds = userSession.sessionIds || [];
//       const initialSessionId = getNextAvailableSessionId(existingSessionIds);

//       console.log(initialSessionId, "Initial session ID determined");
//       setCurrentSessionId(initialSessionId);
//       setLatestSession(initialSessionId);

//       // sessionStorage.setItem("sessionNumber", initialSessionId);
//       setSessionNumber(initialSessionId);
//     }

//   }, [isDev, userSession.sessionIds]);

//   useEffect(() => {
//     if ('permissions' in navigator) {
//       navigator.permissions.query({ name: 'microphone' })
//         .then(permissionStatus => {
//           setPermission(permissionStatus.state);
//           permissionStatus.onchange = () => {
//             setPermission(permissionStatus.state);
//           };
//         })
//         .catch(console.error);
//     }
//   }, []);

//   const requestMicrophonePermission = async () => {
//     try {
//       const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
//       stream.getTracks().forEach(track => track.stop());
//       setPermission('granted');
//       return true;
//     } catch (error) {
//       console.error('Microphone permission denied:', error);
//       setPermission('denied');
//       return false;
//     }
//   };

//   const handleClick = async () => {
//     if (!browserSupportsSpeechRecognition) {
//       alert('Your browser does not support speech recognition.');
//       return;
//     }
//     if (permission !== 'granted') {
//       const granted = await requestMicrophonePermission();
//       if (!granted) {
//         alert('Microphone permission is required for speech recognition.');
//         return;
//       }
//     }
//     if (listening) {
//       SpeechRecognition.abortListening();
//       resetTranscript();
//     } else {
//       startListening();
//     }
//   };

//   useEffect(() => {
//     if (transcript) {
//       setQuestion(transcript);
//     }
//   }, [transcript])

//   useEffect(() => {
//     fetchSessions();
//   }, [fetchSessions])

//   const isLastAIResponse = (msg) => {
//     const aiMessages = conversation.filter((item) => item.sender === "ai");
//     return (
//       aiMessages.length > 0 && msg.id === aiMessages[aiMessages.length - 1].id
//     );
//   };

//   useEffect(() => {
//     if (conversation?.length) {
//       const links = document.querySelectorAll('.responseStream_Main a');
//       links.forEach((link) => link.setAttribute('target', '_blank'));
//     }
//   }, [conversation]);

//   const kioskWidth = window.innerWidth;
//   // const kioskHeight = (window.screen && window.screen.height) ? window.screen.height : window.innerHeight;

//   const isUrdu = (text) => /[\u0600-\u06FF]/.test(text);

//   function isArabic(text) {
//     return /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/.test(text);
//   }

//   if (kioskWidth === 1080) {
//     return (
//       <div dir={dir} className="w-full">
//         <style>
//           {`
//           .custom-scrollbar::-webkit-scrollbar {
//             width: 5px;
//           }

//           .custom-scrollbar::-webkit-scrollbar-track {
//             background: #f1f1f1;
//             border-radius: 10px;
//             display: none;
//           }

//           .custom-scrollbar::-webkit-scrollbar-thumb {
//             background: #B03982;
//             border-radius: 10px;
//             display: none;
//           }

//           .custom-scrollbar.has-content::-webkit-scrollbar-track,
//           .custom-scrollbar.has-content::-webkit-scrollbar-thumb {
//             display: block;
//           }

//           .custom-scrollbar::-webkit-scrollbar-thumb:hover {
//             background: #8c2d66;
//           }

//           .whitespace-pre-line {
//             white-space: pre-line;
//           }

//           .active-rating {
//             color: #B03982 !important;
//           }
//         `}
//         </style>
//         <div className="w-full flex items-end justify-between">
//           {/* Middle Div - Main Chat Area */}
//           <div className="p-4 flex flex-col justify-between flex-1 max-w-[80%] ml-36 h-[90vh]">
//             {/* Top Section - Chat Messages */}
//             <div
//               className="flex flex-col gap-4 overflow-y-scroll custom-scrollbar"
//               ref={chatContainerRef}
//             >
//               {/* Header with new session handler */}
//               <Header dir={dir} onStartNewSession={handleNewSession} />

//               {/* Display session history */}
//               <div className="session-list mt-4">
//                 {latestSession && (
//                   <h2 className="text-lg font-bold">{latestSession}</h2>
//                 )}
//               </div>
//               {/* Greeting Card */}
//               {conversation.length === 0 && (
//                 <div className="w-full p-4 bg-gray-100 rounded-lg shadow-md">
//                   <p className="text-lg font-semibold text-gray-800 mb-2">
//                     {t("start_msg")}
//                   </p>
//                 </div>
//               )}

//               {/* Question and Response Area */}

//               <div className="space-y-4">
//                 {conversation.map((msg) => (
//                   <div
//                     key={msg.id}
//                     className={`flex w-full mb-4 ${msg.sender === "user" ? "justify-end" : "justify-start"}`}
//                   >
//                     {msg.sender === "user" ? (
//                       <div className={`flex items-start gap-2 w-full ${dir === 'rtl' ? 'flex-row-reverse' : ''}`}>
//                         {/* Avatar */}
//                         <div className="w-12 h-12 flex-shrink-0 cursor-pointer bg-gray-100 rounded-full border-4 border-[#B03982] flex items-center justify-center hover:shadow-lg transition-shadow">
//                           <span className="text-black text-[18px] font-semibold">
//                             {parsedDataOutScope?.name?.split(" ").map(w => w[0]).slice(0, 2).join("").toUpperCase()}
//                           </span>
//                         </div>

//                         {/* Message / Edit area */}
//                         <div className="flex-1 group relative">
//                           {editingMessageId === msg.id ? (
//                             /* ── Edit mode ── */
//                             <div className="flex flex-col gap-2">
//                               <textarea
//                                 autoFocus
//                                 value={editingText}
//                                 onChange={(e) => setEditingText(e.target.value)}
//                                 onKeyDown={(e) => {
//                                   if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); handleSaveEdit(); }
//                                   if (e.key === "Escape") handleCancelEdit();
//                                 }}
//                                 className="w-full p-3 rounded-lg border-2 border-[#B03982] focus:outline-none resize-none text-gray-900 bg-white shadow-md"
//                                 rows={3}
//                               />
//                               <div className="flex gap-2 justify-end">
//                                 <button
//                                   onClick={handleCancelEdit}
//                                   className="px-4 py-1.5 text-sm rounded-full border border-gray-400 text-gray-600 hover:bg-gray-100 transition-colors"
//                                 >
//                                   Cancel
//                                 </button>
//                                 <button
//                                   onClick={handleSaveEdit}
//                                   disabled={!editingText.trim() || loading}
//                                   className="px-4 py-1.5 text-sm rounded-full bg-[#B03982] text-white hover:bg-[#902F6A] disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
//                                 >
//                                   Send
//                                 </button>
//                               </div>
//                             </div>
//                           ) : (
//                             /* ── Display mode ── */
//                             <div className={`relative p-3 rounded-lg shadow-md bg-gray-100 text-gray-900 ${isUrdu(msg.message) || isArabic(msg.message) ? "text-right" : "text-left"}`}>
//                               <h3 className="text-base font-semibold break-words whitespace-normal pr-7">
//                                 {msg.message}
//                               </h3>
//                               {/* Pencil icon — visible on hover */}
//                               {!loading && (
//                                 <button
//                                   onClick={() => handleEditMessage(msg)}
//                                   className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity p-1 rounded-md hover:bg-gray-200 text-gray-500 hover:text-[#B03982]"
//                                   aria-label="Edit message"
//                                 >
//                                   <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
//                                     fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                                     <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
//                                     <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
//                                   </svg>
//                                 </button>
//                               )}
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                     ) : (
//                       <div
//                         className={`flex items-start w-full text-right gap-2`}
//                       >
//                         {/* gap-2 AI avatar */}
//                         {/* <div className="w-14 h-14 cursor-pointer rounded-full bg-white flex items-center justify-center"> */}
//                         <span className="w-14 h-14">
//                           <img src={nerdyicon} alt="AI" />
//                         </span>
//                         {/* </div> */}

//                         {/* AI response */}
//                         <div
//                           className={`flex-1 p-4 rounded-lg shadow-md bg-gray-100 text-gray-700 break-words whitespace-normal ${isUrdu(msg.message) || isArabic(msg.message) ? "text-right" : "text-left"
//                             }`}
//                         >
//                           <ReactMarkdown
//                             className="responseStream_Main"
//                             children={msg.message}
//                             remarkPlugins={[remarkGfm]}
//                             rehypePlugins={[rehypeRaw]}
//                             unwrapDisallowed={false}
//                           // components={{
//                           //   a: ({ node, ...props }) => (
//                           //     <a
//                           //       {...props}
//                           //       target="_blank"
//                           //     />
//                           //   )
//                           // }}
//                           />

//                           {/* Rating buttons */}
//                           {isLastAIResponse(msg) && (
//                             <div className={`flex ${dir === 'rtl' ? 'justify-end' : ''} mt-2 space-x-2`}>
//                               <button
//                                 className={`text-gray-400 hover:text-black ml-2 ${msg.ratingGiven === "ThumbsUp" ? "active-rating" : ""}`}
//                                 onClick={() => handleRating(msg.id, "ThumbsUp")}
//                               >
//                                 <svg
//                                   xmlns="http://www.w3.org/2000/svg"
//                                   width="20"
//                                   height="20"
//                                   viewBox="0 0 24 24"
//                                   fill="none"
//                                   stroke="currentColor"
//                                   strokeWidth="2"
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                 >
//                                   <path d="M7 10v12" />
//                                   <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a3.13 3.13 0 0 1 3 3.88Z" />
//                                 </svg>
//                               </button>
//                               <button
//                                 className={`text-gray-400 hover:text-black ml-2 ${msg.ratingGiven === "ThumbsDown" ? "active-rating" : ""}`}
//                                 onClick={() => handleRating(msg.id, "ThumbsDown")}
//                               >
//                                 <svg
//                                   xmlns="http://www.w3.org/2000/svg"
//                                   width="20"
//                                   height="20"
//                                   viewBox="0 0 24 24"
//                                   fill="none"
//                                   stroke="currentColor"
//                                   strokeWidth="2"
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                 >
//                                   <path d="M17 14V2" />
//                                   <path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22h0a3.13 3.13 0 0 1-3-3.88Z" />
//                                 </svg>
//                               </button>
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 ))}
//                 <div>
//                   {loading && (
//                     <div className="flex items-center justify-center w-full">
//                       <img
//                         src={loadingGif}
//                         alt={t("loading")}
//                         className="w-60"
//                       />
//                     </div>
//                   )}

//                   {responseStream && (
//                     <div className="w-full p-4 bg-gray-100 rounded-lg shadow-md">
//                       <ReactMarkdown
//                         className="text-gray-700 responseStream_Main"
//                         children={responseStream}
//                         remarkPlugins={[remarkGfm]}
//                         rehypePlugins={[rehypeRaw]}
//                         unwrapDisallowed={false}
//                       />
//                     </div>
//                   )}
//                 </div>
//               </div>



//             </div>
//             {/* Bottom Section - Input Area */}
//             <div className="relative w-full">
//               <ScrollButton helperButton={helperButton} chatContainerRef={chatContainerRef} />
//               <div>
//                 {helperButton && (
//                   <div className="flex justify-center gap-10 mb-10 mt-10">
//                     {references && references !== "No references found." && (
//                       <button
//                         onClick={handleNavigateToReferences}
//                         disabled={helperLoader}
//                         className={`px-4 py-2 border-2 border-[#B03982] rounded-3xl w-[11rem] ${helperLoader
//                           ? "bg-gray-300 text-gray-600 cursor-not-allowed"
//                           : "bg-transparent text-[#B03982] hover:bg-[#B03982] hover:text-white"
//                           }`}
//                       >
//                         {t("show_refernces")}
//                       </button>
//                     )}
//                     {suggestedQuestions.length > 0 && (
//                       <button
//                         onClick={handleRefineSuggestions}
//                         disabled={helperLoader}
//                         className={`px-4 py-2 rounded-3xl w-[11rem] ${helperLoader
//                           ? "bg-gray-300 text-gray-600 cursor-not-allowed"
//                           : "bg-[#B03982] text-white hover:bg-[#8c2d66]"
//                           }`}
//                       >
//                         {t("refine_it")}
//                       </button>
//                     )}
//                     {documentCount > 1 &&
//                       suggestedQuestions.length > 0 &&
//                       references &&
//                       references !== "No references found." && (
//                         <button
//                           onClick={handleEditDoc}
//                           disabled={helperLoader}
//                           className={`px-4 py-2 rounded-3xl w-[11rem] ${helperLoader
//                             ? "bg-gray-300 text-gray-600 cursor-not-allowed"
//                             : "bg-[#B03982] text-white hover:bg-[#8c2d66]"
//                             }`}
//                         >
//                           {t("select_document")}
//                         </button>
//                       )}
//                   </div>
//                 )}
//               </div>
//               <div className="flex items-center border border-gray-300 rounded-lg focus-within:ring-2 focus-within:ring-[#B03982] overflow-hidden min-h-[3.5rem]">
//                 <textarea
//                   value={question}
//                   onChange={(e) => setQuestion(e.target.value)}
//                   onKeyDown={(e) => {
//                     if (
//                       e.key === "Enter" &&
//                       !e.shiftKey &&
//                       question.trim() &&
//                       !loading
//                     ) {
//                       e.preventDefault();
//                       handleSend();
//                     }
//                   }}
//                   placeholder={t("ask_buddy")}
//                   disabled={loading}
//                   className="flex-grow h-full px-4 py-3 focus:outline-none resize-none disabled:cursor-not-allowed placeholder:text-gray-500"
//                   rows={1}
//                   style={{
//                     minHeight: '44px',
//                     maxHeight: '120px',
//                   }}
//                 />

//                 {/* Mic/Record Button */}
//                 <button
//                   onClick={handleClick}
//                   disabled={loading}
//                   className={`px-2 h-full flex items-center justify-center ${dir === 'rtl' ? 'border-l' : 'border-r'} border-gray-300 disabled:opacity-50 disabled:cursor-not-allowed`}
//                   aria-label={listening ? "Stop recording" : "Start recording"}
//                 >
//                   {listening ? (
//                     <div className="flex items-center justify-center">
//                       <div className="w-8 h-8 rounded-full bg-red-500 flex items-center justify-center animate-pulse">
//                         <div className="w-4 h-4 rounded-sm bg-white"></div>
//                       </div>
//                     </div>
//                   ) : (
//                     <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
//                       <svg className="w-8 h-8 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
//                         <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
//                         <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
//                       </svg>
//                     </div>
//                   )}
//                 </button>

//                 {/* Action Button (Send/Pause) */}
//                 <div className="mx-2">
//                   {(loading || responseStream) ? (
//                     <button
//                       onClick={stopStream}
//                       disabled={!(loading || responseStream)}
//                       className={`h-10 w-10 rounded-lg flex items-center justify-center text-white font-semibold bg-red-500 hover:bg-red-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors`}
//                       aria-label="Stop"
//                     >
//                       <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//                         <rect x="6" y="6" width="12" height="12" />
//                       </svg>
//                     </button>
//                   ) : (
//                     <button
//                       onClick={handleSend}
//                       disabled={!question.trim() || loading}
//                       className={`h-10 w-10 rounded-lg flex items-center justify-center text-white font-semibold transition-colors ${question.trim() && !loading
//                         ? "bg-[#B03982] hover:bg-[#902F6A]"
//                         : "bg-gray-300 cursor-not-allowed"
//                         }`}
//                       aria-label="Send message"
//                     >
//                       <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//                         <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
//                       </svg>
//                     </button>
//                   )}
//                 </div>
//               </div>
//               <p className="text-gray-500 text-center mt-3">NerdyBuddy can be inaccurate; please double check its responses.</p>
//             </div>
//           </div>
//           {/* Third Div - Character Image */}
//           <div className="p-4 pl-8 gap-36 flex flex-col">
//             <div className="w-[16rem] h-[20rem]">
//               <CharacterDisplay loading={loading} />
//               {/* <img src={Character} alt="Character" className="w-full h-full object-cover relative z-[-1]" /> */}
//             </div>
//           </div>
//           <Modal
//             isOpen={isModalOpen}
//             onClose={() => setIsModalOpen(false)}
//             type={modalType}
//           >
//             {modalType === "refine" && (
//               <Refine
//                 suggestedQuestions={suggestedQuestions}
//                 onSelectOption={handleSelectOption}
//                 onCloseModal={() => setIsModalOpen(false)}
//                 refineCount={refineCount}
//               />
//             )}
//             {modalType === "doc" && (
//               <Doc
//                 // documentDetails={documentDetails}
//                 documentDetails={documentInfo}
//                 onSelectOption={handleSelectOption}
//                 onCloseModal={() => setIsModalOpen(false)}
//                 dir={dir}
//               />
//             )}
//             {modalType === "references" && (
//               <References
//                 isOpen={isModalOpen}
//                 onClose={() => setIsModalOpen(false)}
//                 references={references}
//                 documentInfo={documentInfo}
//                 dir={dir}
//               />
//             )}
//           </Modal>
//         </div>
//       </div>
//     )
//   } else {
//     return (
//       <div dir={dir} className="min-h-full w-full flex" style={{ height: 'calc(100vh - 90px)' }}>
//         <style>
//           {`
//           .custom-scrollbar::-webkit-scrollbar {
//             width: 5px;
//           }

//           .custom-scrollbar::-webkit-scrollbar-track {
//             background: #f1f1f1;
//             border-radius: 10px;
//             display: none;
//           }

//           .custom-scrollbar::-webkit-scrollbar-thumb {
//             background: #B03982;
//             border-radius: 10px;
//             display: none;
//           }

//           .custom-scrollbar.has-content::-webkit-scrollbar-track,
//           .custom-scrollbar.has-content::-webkit-scrollbar-thumb {
//             display: block;
//           }

//           .custom-scrollbar::-webkit-scrollbar-thumb:hover {
//             background: #8c2d66;
//           }

//           .whitespace-pre-line {
//             white-space: pre-line;
//           }

//           .active-rating {
//             color: #B03982 !important;
//           }
//         `}
//         </style>
//         <div className="w-full flex items-end justify-between">
//           {/* First Div - Character Image */}
//           <div></div>

//           {/* Middle Div - Main Chat Area */}
//           <div className="h-screen p-4 flex flex-col justify-between flex-1 max-w-[50%] ml-20">
//             {/* Top Section - Chat Messages */}
//             <div
//               className="flex flex-col gap-4 mt-[3.5rem] h-full overflow-y-scroll custom-scrollbar"
//               ref={chatContainerRef}
//             >
//               {/* Header with new session handler */}
//               <Header dir={dir} onStartNewSession={handleNewSession} />

//               {/* Display session history */}
//               <div className="session-list mt-4">
//                 {latestSession && (
//                   <h2 className="text-lg font-bold">{latestSession}</h2>
//                 )}
//               </div>
//               {/* Greeting Card */}
//               {conversation.length === 0 && (
//                 <div className="w-full p-4 bg-gray-100 rounded-lg shadow-md">
//                   <p className="text-lg font-semibold text-gray-800 mb-2">
//                     {t("start_msg")}
//                   </p>
//                 </div>
//               )}

//               {/* Question and Response Area */}
//               {/* <div className="space-y-4">
//                 {conversation.map((msg) => (
//                   <div
//                     key={msg.id}
//                     className={`flex w-full mb-4 ${msg.sender === "user" ? "justify-end" : "justify-start"}`}
//                   >
//                     {msg.sender === "user" ? (
//                       <div className={`flex items-center gap-5 w-full text-right`}>
//                         <div className="w-12 h-12 cursor-pointer bg-gray-100 object-cover rounded-full border-4 border-[#B03982] flex items-center justify-center hover:shadow-lg transition-shadow">
//                           <span className="text-black text-[18px] font-semibold">
//                             {parsedDataOutScope?.name
//                               ?.split(" ")
//                               .map(word => word[0])
//                               .slice(0, 2)
//                               .join("")
//                               .toUpperCase()
//                             }
//                           </span>
//                         </div>
//                         <div className={`flex-1 p-2 rounded-lg shadow-md bg-gray-100 text-gray-900 ${isUrdu(msg.message) || isArabic(msg.message) ? "text-right" : "text-left"}`}>
//                           <h3 className="text-lg font-semibold break-words whitespace-normal">
//                             {msg.message}
//                           </h3>
//                         </div>
//                       </div>
//                     ) : (
//                       <div className={`flex items-start w-full text-right gap-5`}>
//                         <span className="w-12 h-12">
//                           <img src={nerdyicon} alt="AI" />
//                         </span>
//                         <div className={`flex-1 p-4 rounded-lg shadow-md bg-gray-100 text-gray-700 break-words whitespace-normal ${isUrdu(msg.message) || isArabic(msg.message) ? "text-right" : "text-left"}`}>
//                           <ReactMarkdown
//                             className="responseStream_Main"
//                             children={msg.message}
//                             remarkPlugins={[remarkGfm]}
//                             rehypePlugins={[rehypeRaw]}
//                             unwrapDisallowed={false}
//                           />
//                           {isLastAIResponse(msg) && (
//                             <div className={`flex ${dir === 'rtl' ? 'justify-end' : ''} mt-2 space-x-2`}>
//                               <button
//                                 className={`text-gray-400 hover:text-black ml-2 ${msg.ratingGiven === "ThumbsUp" ? "active-rating" : ""}`}
//                                 onClick={() => handleRating(msg.id, "ThumbsUp")}
//                               >
//                                 <svg
//                                   xmlns="http://www.w3.org/2000/svg"
//                                   width="20"
//                                   height="20"
//                                   viewBox="0 0 24 24"
//                                   fill="none"
//                                   stroke="currentColor"
//                                   strokeWidth="2"
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                 >
//                                   <path d="M7 10v12" />
//                                   <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a3.13 3.13 0 0 1 3 3.88Z" />
//                                 </svg>
//                               </button>
//                               <button
//                                 className={`text-gray-400 hover:text-black ml-2 ${msg.ratingGiven === "ThumbsDown" ? "active-rating" : ""}`}
//                                 onClick={() => handleRating(msg.id, "ThumbsDown")}
//                               >
//                                 <svg
//                                   xmlns="http://www.w3.org/2000/svg"
//                                   width="20"
//                                   height="20"
//                                   viewBox="0 0 24 24"
//                                   fill="none"
//                                   stroke="currentColor"
//                                   strokeWidth="2"
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                 >
//                                   <path d="M17 14V2" />
//                                   <path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22h0a3.13 3.13 0 0 1-3-3.88Z" />
//                                 </svg>
//                               </button>
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 ))}
//                 <div>
//                   {loading && (
//                     <div className="flex items-center justify-center w-full">
//                       <img
//                         src={loadingGif}
//                         alt={t("loading")}
//                         className="w-60"
//                       />
//                     </div>
//                   )}
//                   {responseStream && (
//                     <div className={`flex items-start w-full gap-5`}>
//                       <span className="w-12 h-12">
//                         <img src={nerdyicon} alt="AI" />
//                       </span>
//                       <div className="w-full p-4 bg-gray-100 rounded-lg shadow-md">
//                         <ReactMarkdown
//                           className="text-gray-700 responseStream_Main"
//                           children={responseStream}
//                           remarkPlugins={[remarkGfm]}
//                           rehypePlugins={[rehypeRaw]}
//                           unwrapDisallowed={false}
//                         />
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div> */}

//               {/* Question and Response Area */}
//               <div className="space-y-4">
//                 {conversation.map((msg) => (
//                   <div
//                     key={msg.id}
//                     className={`flex w-full mb-4 ${msg.sender === "user" ? "justify-end" : "justify-start"}`}
//                   >
//                     {msg.sender === "user" ? (
//                       <div className={`flex items-start gap-2 w-full ${dir === 'rtl' ? 'flex-row-reverse' : ''}`}>
//                         {/* Avatar */}
//                         <div className="w-12 h-12 flex-shrink-0 cursor-pointer bg-gray-100 rounded-full border-4 border-[#B03982] flex items-center justify-center hover:shadow-lg transition-shadow">
//                           <span className="text-black text-[18px] font-semibold">
//                             {parsedDataOutScope?.name?.split(" ").map(w => w[0]).slice(0, 2).join("").toUpperCase()}
//                           </span>
//                         </div>

//                         {/* Message / Edit area */}
//                         <div className="flex-1 group relative">
//                           {editingMessageId === msg.id ? (
//                             /* ── Edit mode ── */
//                             <div className="flex flex-col gap-2">
//                               <textarea
//                                 autoFocus
//                                 value={editingText}
//                                 onChange={(e) => setEditingText(e.target.value)}
//                                 onKeyDown={(e) => {
//                                   if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); handleSaveEdit(); }
//                                   if (e.key === "Escape") handleCancelEdit();
//                                 }}
//                                 className="w-full p-3 rounded-lg border-2 border-[#B03982] focus:outline-none resize-none text-gray-900 bg-white shadow-md"
//                                 rows={3}
//                               />
//                               <div className="flex gap-2 justify-end">
//                                 <button
//                                   onClick={handleCancelEdit}
//                                   className="px-4 py-1.5 text-sm rounded-full border border-gray-400 text-gray-600 hover:bg-gray-100 transition-colors"
//                                 >
//                                   Cancel
//                                 </button>
//                                 <button
//                                   onClick={handleSaveEdit}
//                                   disabled={!editingText.trim() || loading}
//                                   className="px-4 py-1.5 text-sm rounded-full bg-[#B03982] text-white hover:bg-[#902F6A] disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
//                                 >
//                                   Send
//                                 </button>
//                               </div>
//                             </div>
//                           ) : (
//                             /* ── Display mode ── */
//                             <div className={`relative p-3 rounded-lg shadow-md bg-gray-100 text-gray-900 ${isUrdu(msg.message) || isArabic(msg.message) ? "text-right" : "text-left"}`}>
//                               <h3 className="text-base font-semibold break-words whitespace-normal pr-7">
//                                 {msg.message}
//                               </h3>
//                               {/* Pencil icon — visible on hover */}
//                               {!loading && (
//                                 <button
//                                   onClick={() => handleEditMessage(msg)}
//                                   className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity p-1 rounded-md hover:bg-gray-200 text-gray-500 hover:text-[#B03982]"
//                                   aria-label="Edit message"
//                                 >
//                                   <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
//                                     fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                                     <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
//                                     <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
//                                   </svg>
//                                 </button>
//                               )}
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                     ) : (
//                       <div
//                         className={`flex items-start w-full text-right gap-2`}
//                       >
//                         {/* gap-2 AI avatar */}
//                         {/* <div className="w-14 h-14 cursor-pointer rounded-full bg-white flex items-center justify-center"> */}
//                         <span className="w-14 h-14">
//                           <img src={nerdyicon} alt="AI" />
//                         </span>
//                         {/* </div> */}

//                         {/* AI response */}
//                         <div
//                           className={`flex-1 p-4 rounded-lg shadow-md bg-gray-100 text-gray-700 break-words whitespace-normal ${isUrdu(msg.message) || isArabic(msg.message) ? "text-right" : "text-left"
//                             }`}
//                         >
//                           <ReactMarkdown
//                             className="responseStream_Main"
//                             children={msg.message}
//                             remarkPlugins={[remarkGfm]}
//                             rehypePlugins={[rehypeRaw]}
//                             unwrapDisallowed={false}
//                           // components={{
//                           //   a: ({ node, ...props }) => (
//                           //     <a
//                           //       {...props}
//                           //       target="_blank"
//                           //     />
//                           //   )
//                           // }}
//                           />

//                           {/* Rating buttons */}
//                           {isLastAIResponse(msg) && (
//                             <div className={`flex ${dir === 'rtl' ? 'justify-end' : ''} mt-2 space-x-2`}>
//                               <button
//                                 className={`text-gray-400 hover:text-black ml-2 ${msg.ratingGiven === "ThumbsUp" ? "active-rating" : ""}`}
//                                 onClick={() => handleRating(msg.id, "ThumbsUp")}
//                               >
//                                 <svg
//                                   xmlns="http://www.w3.org/2000/svg"
//                                   width="20"
//                                   height="20"
//                                   viewBox="0 0 24 24"
//                                   fill="none"
//                                   stroke="currentColor"
//                                   strokeWidth="2"
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                 >
//                                   <path d="M7 10v12" />
//                                   <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a3.13 3.13 0 0 1 3 3.88Z" />
//                                 </svg>
//                               </button>
//                               <button
//                                 className={`text-gray-400 hover:text-black ml-2 ${msg.ratingGiven === "ThumbsDown" ? "active-rating" : ""}`}
//                                 onClick={() => handleRating(msg.id, "ThumbsDown")}
//                               >
//                                 <svg
//                                   xmlns="http://www.w3.org/2000/svg"
//                                   width="20"
//                                   height="20"
//                                   viewBox="0 0 24 24"
//                                   fill="none"
//                                   stroke="currentColor"
//                                   strokeWidth="2"
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                 >
//                                   <path d="M17 14V2" />
//                                   <path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22h0a3.13 3.13 0 0 1-3-3.88Z" />
//                                 </svg>
//                               </button>
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 ))}
//                 <div>
//                   {loading && (
//                     <div className="flex items-center justify-center w-full">
//                       <img
//                         src={loadingGif}
//                         alt={t("loading")}
//                         className="w-60"
//                       />
//                     </div>
//                   )}

//                   {responseStream && (
//                     <div className="w-full p-4 bg-gray-100 rounded-lg shadow-md">
//                       <ReactMarkdown
//                         className="text-gray-700 responseStream_Main"
//                         children={responseStream}
//                         remarkPlugins={[remarkGfm]}
//                         rehypePlugins={[rehypeRaw]}
//                         unwrapDisallowed={false}
//                       />
//                     </div>
//                   )}
//                 </div>
//               </div>

//             </div>
//             {/* Bottom Section - Input Area */}
//             <div className="relative w-full ">
//               <ScrollButton helperButton={helperButton} chatContainerRef={chatContainerRef} />
//               {helperButton && (
//                 <div className="flex justify-center gap-4 mb-4 mt-4">
//                   {references && references !== "No references found." && (
//                     <button
//                       onClick={handleNavigateToReferences}
//                       disabled={helperLoader}
//                       className={`px-4 py-2 border-2 border-[#B03982] rounded-full text-sm min-w-[110px] ${helperLoader
//                         ? "bg-gray-300 text-gray-600 cursor-not-allowed"
//                         : "bg-transparent text-[#B03982] hover:bg-[#B03982] hover:text-white"
//                         }`}
//                     >
//                       {t("show_refernces")}
//                     </button>
//                   )}

//                   {suggestedQuestions.length > 0 && (
//                     <button
//                       onClick={handleRefineSuggestions}
//                       disabled={helperLoader}
//                       className={`px-4 py-2 rounded-full text-sm min-w-[110px] ${helperLoader
//                         ? "bg-gray-300 text-gray-600 cursor-not-allowed"
//                         : "bg-[#B03982] text-white hover:bg-[#8c2d66]"
//                         }`}
//                     >
//                       {t("refine_it")}
//                     </button>
//                   )}

//                   {documentCount > 1 &&
//                     suggestedQuestions.length > 0 &&
//                     references &&
//                     references !== "No references found." && (
//                       <button
//                         onClick={handleEditDoc}
//                         disabled={helperLoader}
//                         className={`px-4 py-2 rounded-full text-sm min-w-[110px] ${helperLoader
//                           ? "bg-gray-300 text-gray-600 cursor-not-allowed"
//                           : "bg-[#B03982] text-white hover:bg-[#8c2d66]"
//                           }`}
//                       >
//                         {t("select_document")}
//                       </button>
//                     )}
//                 </div>
//               )}
//               <div className="flex items-center border border-gray-300 rounded-lg focus-within:ring-2 focus-within:ring-[#B03982] overflow-hidden min-h-[3.5rem]">
//                 <textarea
//                   value={question}
//                   onChange={(e) => setQuestion(e.target.value)}
//                   onKeyDown={(e) => {
//                     if (
//                       e.key === "Enter" &&
//                       !e.shiftKey &&
//                       question.trim() &&
//                       !loading
//                     ) {
//                       e.preventDefault();
//                       handleSend();
//                     }
//                   }}
//                   placeholder={t("ask_buddy")}
//                   disabled={loading}
//                   className="flex-grow h-full px-4 py-3 focus:outline-none resize-none disabled:cursor-not-allowed placeholder:text-gray-500"
//                   rows={1}
//                   style={{
//                     minHeight: '44px',
//                     maxHeight: '120px',
//                   }}
//                 />

//                 {/* Mic/Record Button */}
//                 <button
//                   onClick={handleClick}
//                   disabled={loading}
//                   className={`px-2 h-full flex items-center justify-center ${dir === 'rtl' ? 'border-l' : 'border-r'} border-gray-300 disabled:opacity-50 disabled:cursor-not-allowed`}
//                   aria-label={listening ? "Stop recording" : "Start recording"}
//                 >
//                   {listening ? (
//                     <div className="flex items-center justify-center">
//                       <div className="w-8 h-8 rounded-full bg-red-500 flex items-center justify-center animate-pulse">
//                         <div className="w-4 h-4 rounded-sm bg-white"></div>
//                       </div>
//                     </div>
//                   ) : (
//                     <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
//                       <svg className="w-8 h-8 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
//                         <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
//                         <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
//                       </svg>
//                     </div>
//                   )}
//                 </button>

//                 {/* Action Button (Send/Pause) */}
//                 <div className="mx-2">
//                   {(loading || responseStream) ? (
//                     <button
//                       onClick={stopStream}
//                       disabled={!(loading || responseStream)}
//                       className={`h-10 w-10 rounded-lg flex items-center justify-center text-white font-semibold bg-red-500 hover:bg-red-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors`}
//                       aria-label="Stop"
//                     >
//                       <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//                         <rect x="6" y="6" width="12" height="12" />
//                       </svg>
//                     </button>
//                   ) : (
//                     <button
//                       onClick={handleSend}
//                       disabled={!question.trim() || loading}
//                       className={`h-10 w-10 rounded-lg flex items-center justify-center text-white font-semibold transition-colors ${question.trim() && !loading
//                         ? "bg-[#B03982] hover:bg-[#902F6A]"
//                         : "bg-gray-300 cursor-not-allowed"
//                         }`}
//                       aria-label="Send message"
//                     >
//                       <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//                         <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
//                       </svg>
//                     </button>
//                   )}
//                 </div>
//               </div>
//               <p className="text-gray-500 text-center mt-2">NerdyBuddy can be inaccurate; please double check its responses.</p>
//             </div>
//           </div>

//           {/* Third Div - Character Image */}
//           <div className="p-4 pl-8 gap-36 flex flex-col">
//             <div className="w-[20rem] h-[26rem]">
//               <CharacterDisplay loading={loading} />
//               {/* <img src={Character} alt="Character" className="w-full h-full object-cover relative z-[-1]" /> */}
//             </div>
//           </div>
//           <Modal
//             isOpen={isModalOpen}
//             onClose={() => setIsModalOpen(false)}
//             type={modalType}
//           >
//             {modalType === "refine" && (
//               <Refine
//                 suggestedQuestions={suggestedQuestions}
//                 onSelectOption={handleSelectOption}
//                 onCloseModal={() => setIsModalOpen(false)}
//                 refineCount={refineCount}
//               />
//             )}
//             {modalType === "doc" && (
//               <Doc
//                 // documentDetails={documentDetails}
//                 documentDetails={documentInfo}
//                 onSelectOption={handleSelectOption}
//                 onCloseModal={() => setIsModalOpen(false)}
//                 dir={dir}
//               />
//             )}
//             {modalType === "references" && (
//               <References
//                 isOpen={isModalOpen}
//                 onClose={() => setIsModalOpen(false)}
//                 references={references}
//                 documentInfo={documentInfo}
//                 dir={dir}
//               />
//             )}
//           </Modal>
//         </div>
//         {/* <Recording /> */}
//         <LiveChat />
//       </div>
//     );
//   }

// };

// export default Home;

// import React, { useState, useEffect, useRef, useCallback } from "react";
// import Modal from "./Modal";
// import Refine from "./refine";
// import References from "./References";
// import Doc from "./documentselector";
// import loadingGif from "../assest/Loading.gif";
// import ReactMarkdown from "react-markdown";
// import remarkGfm from "remark-gfm";
// import Header from "../components/Header.js";
// import ScrollButton from "./ScrollButton";
// import rehypeRaw from 'rehype-raw';
// import CharacterDisplay from "./CharacterDisplay.jsx";
// import nerdyicon from "../assest/logo2.png";
// import { useTranslation } from "react-i18next";
// import { useNavigate } from "react-router-dom";
// import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
// import axios from "axios";
// import { logout } from "../features/auth/authSlice.js";
// import { useDispatch } from "react-redux";
// // import LiveChat from "../components/LiveChat.jsx";
// import parse from "html-react-parser";

// const TaxInitialAllowance = ({ message }) => {
//   console.log(message);
//   return (
//     <div className="prose max-w-none p-6 bg-white rounded-lg border border-gray-100 shadow">
//       {parse(message)}
//     </div>
//   );
// };

// // ── HTML response section patterns ──────────────────────────────────────────
// // The backend now streams HTML (not markdown), so the References / followUp /
// // Referenced Files sections need to be matched as HTML blocks instead of the
// // old "**References:**" style markdown markers.
// //
// // Expected shapes coming back from the API:
// //   <h3>References:</h3><table>...</table>
// //   <strong>followUp:</strong><br>Question: ...<br>1. ...<br>2. ...
// //   <section><h3>Referenced Files</h3><ul><li>name.pdf: 0.87</li>...</ul></section>

// const REFERENCES_PATTERN = /<h3>\s*References:?\s*<\/h3>\s*<table>[\s\S]*?<\/table>/i;
// const FOLLOWUP_PATTERN = /<strong>\s*followUp:?\s*<\/strong>([\s\S]*?)(?=<section>|$)/i;
// const REFERENCED_FILES_BLOCK_PATTERN = /<section>\s*<h3>\s*Referenced Files\s*<\/h3>[\s\S]*?<\/section>/i;
// const REFERENCED_FILES_LIST_PATTERN = /<section>\s*<h3>\s*Referenced Files\s*<\/h3>\s*<ul>([\s\S]*?)<\/ul>\s*<\/section>/i;
// const REFERENCED_FILE_ITEM_PATTERN = /<li>\s*([\s\S]*?)\s*:\s*([\d.]+)\s*<\/li>/g;

// // Removes the References/followUp/Referenced-Files blocks from the HTML that
// // gets rendered in the chat bubble. Safe to call on partial/streaming chunks —
// // a non-matching pattern is simply a no-op.
// function stripSpecialSections(html) {
//   let out = html;
//   out = out.replace(REFERENCES_PATTERN, "");
//   out = out.replace(FOLLOWUP_PATTERN, "");
//   out = out.replace(REFERENCED_FILES_BLOCK_PATTERN, "");
//   return out.trim();
// }

// // Pulls the raw References block (heading + table) out so it can be shown in
// // the "References" modal.
// function extractReferences(html) {
//   const match = html.match(REFERENCES_PATTERN);
//   return match ? match[0] : "";
// }

// // Pulls the follow-up question + numbered options out of the followUp block.
// function extractFollowUp(html) {
//   const match = html.match(FOLLOWUP_PATTERN);
//   if (!match || !match[1]) return [];

//   const content = match[1].replace(/<br\s*\/?>/gi, "\n").trim();
//   const questionMatch = content.match(/Question:\s*(.*?)(?:\n\d+\.|\n\n|$)/s);
//   const mainQuestion = questionMatch ? questionMatch[1].trim() : "";

//   const options = Array.from(
//     content.matchAll(/\d+\.\s+(.*?)(?=\n\d+\.|\n*$)/gs),
//     (m) => m[1].trim()
//   ).filter(Boolean);

//   if (mainQuestion && options.length > 0) {
//     return [{ question: mainQuestion, options }];
//   }
//   return [];
// }

// // Pulls { fileName, score } pairs out of the Referenced Files <ul><li> list.
// function extractReferencedFileNames(html) {
//   const listMatch = html.match(REFERENCED_FILES_LIST_PATTERN);
//   const files = [];
//   if (listMatch && listMatch[1]) {
//     REFERENCED_FILE_ITEM_PATTERN.lastIndex = 0;
//     let m;
//     while ((m = REFERENCED_FILE_ITEM_PATTERN.exec(listMatch[1])) !== null) {
//       files.push({ fileName: m[1].trim(), score: parseFloat(m[2]) });
//     }
//   }
//   return files;
// }

// const Home = ({ dir }) => {

//   const navigate = useNavigate();
//   const { t } = useTranslation();
//   const dispatch = useDispatch();

//   const chatContainerRef = useRef(null);
//   const streamBufferRef = useRef("");
//   const streamFlushTimerRef = useRef(null);

//   const [question, setQuestion] = useState("");
//   const [currentQuestion, setCurrentQuestion] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [conversation, setConversation] = useState([]);
//   const [references, setReferences] = useState("");
//   const [suggestedQuestions, setSuggestedQuestions] = useState([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [modalType, setModalType] = useState("");
//   const [responseStream, setResponseStream] = useState("");
//   const [helperButton, setHelperButton] = useState(false);
//   const [helperLoader, setHelperLoader] = useState(false);
//   const [refineCount] = useState(0);
//   const [documentCount, setDocumentCount] = useState(0);
//   const [sessionNumber, setSessionNumber] = useState(null);
//   const [latestSession, setLatestSession] = useState();
//   const [currentSessionId, setCurrentSessionId] = useState(null);
//   const [documentInfo, setDocumentInfo] = useState([]);
//   const [userSession, setUserSession] = useState([]);

//   const startListening = () => SpeechRecognition.startListening({ continuous: true, language: 'en-US', interimResults: true });
//   const { transcript, listening, resetTranscript, browserSupportsSpeechRecognition } = useSpeechRecognition();
//   const [permission, setPermission] = useState('prompt');

//   // ── Edit message state ──────────────────────────────────────────────────────
//   const [editingMessageId, setEditingMessageId] = useState(null);
//   const [editingText, setEditingText] = useState("");

//   const streamAbortControllerRef = useRef(null);

//   const storedData = localStorage.getItem("profileData") || sessionStorage.getItem("profileData");
//   let parsedDataOutScope;

//   if (storedData) {
//     const parsedData = JSON.parse(storedData);
//     parsedDataOutScope = parsedData;
//   }

//   const isDev = process.env.NODE_ENV === 'development';

//   const handleSignout = useCallback(() => {

//     localStorage.removeItem("user");
//     localStorage.removeItem("token");
//     localStorage.removeItem("profileData");

//     sessionStorage.removeItem("user");
//     sessionStorage.removeItem("token");
//     sessionStorage.removeItem("profileData");

//     sessionStorage.removeItem("conversation");
//     sessionStorage.removeItem("currentSessionId");
//     sessionStorage.removeItem("sessionNumber");
//     sessionStorage.removeItem("sessions");

//     dispatch(logout())
//     navigate("/login");

//   }, [navigate, dispatch]);

//   const hitRatingApi = async (ratingType, lastQuestion, thisResponse, referenceDoc) => {

//     const response = await fetch(
//       `${process.env.REACT_APP_PORTAL_APP_BASE_URL}/admin/support/rating`,
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           token: `${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
//         },
//         body: JSON.stringify({
//           RatingType: ratingType,
//           question: lastQuestion,
//           answer: thisResponse,
//           documentFileNames: referenceDoc,
//         }),
//       }
//     );
//     console.log(response);
//   }

//   const fetchSessions = useCallback(async () => {
//     try {
//       const baseUrl = process.env.REACT_APP_BASEURL;
//       const token = localStorage.getItem("token") || sessionStorage.getItem("token");

//       if (!token) {

//         localStorage.removeItem("user");
//         localStorage.removeItem("token");
//         localStorage.removeItem("profileData");

//         sessionStorage.removeItem("user");
//         sessionStorage.removeItem("token");
//         sessionStorage.removeItem("profileData");

//         sessionStorage.removeItem("conversation");
//         sessionStorage.removeItem("currentSessionId");
//         sessionStorage.removeItem("sessionNumber");
//         sessionStorage.removeItem("sessions");

//         dispatch(logout())
//         navigate("/login");

//       }

//       const response = await axios.get(`${baseUrl}/get_user_sessions`, {
//         headers: {
//           "Content-Type": "application/json",
//           "Authorization": `Bearer ${token}`,
//         },
//       });

//       const data = response.data;
//       const apiResponse = {
//         sessionIds: data?.sessions?.map(session => session.sessionId)
//       };

//       console.log(apiResponse, "Transformed API Response");
//       setUserSession(apiResponse);
//       return apiResponse;
//     } catch (err) {
//       if (err?.response?.status === 401) {
//         handleSignout();
//       }
//       console.log("Failed to fetch sessions:", err);
//       return [];
//     }
//   }, [navigate, dispatch, handleSignout]);

//   const getNextAvailableSessionId = (existingSessionIds) => {
//     let i = 1;
//     let newId;
//     do {
//       newId = `Session-${i}`;
//       i++;
//     } while (existingSessionIds.includes(newId));
//     return newId;
//   };

//   useEffect(() => {
//     // Only update the sessionStorage if we have a valid current session ID
//     if (currentSessionId && conversation.length > 0) {
//       const savedSessions = JSON.parse(sessionStorage.getItem("sessions")) || [];

//       // Find the index of the current session in the array
//       const sessionIndex = savedSessions.findIndex(session => session.id === currentSessionId);

//       if (sessionIndex >= 0) {
//         // Update the existing session
//         savedSessions[sessionIndex] = {
//           ...savedSessions[sessionIndex],
//           conversation
//         };
//       } else {
//         // Add a new session
//         savedSessions.push({
//           id: currentSessionId,
//           name: latestSession || `Session ${sessionNumber}`,
//           date: new Date().toLocaleString(),
//           conversation
//         });
//       }
//       sessionStorage.setItem("sessions", JSON.stringify(savedSessions));
//       sessionStorage.setItem("conversation", JSON.stringify(conversation));
//     }
//   }, [conversation, currentSessionId, latestSession, sessionNumber]);

//   const handleStream = async () => {

//     if (!question.trim()) return;

//     setDocumentInfo([]);
//     setCurrentQuestion(question);
//     setResponseStream("");
//     setHelperButton(false);
//     setLoading(true);

//     const newUserMessage = {
//       id: `user-${Date.now()}`,
//       sender: "user",
//       message: question,
//     };

//     setConversation((prev) => [...prev, newUserMessage]);

//     try {

//       console.log("check hit open:")
//       const controller = new AbortController();
//       streamAbortControllerRef.current = controller;
//       const responseStream = await fetch(
//         `${process.env.REACT_APP_BASEURL}/stream_response_html`,

//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
//           },
//           signal: controller.signal,
//           body: JSON.stringify({
//             query: question,
//             chat_history: conversation.map((msg) => msg.message),
//             language: "en",
//             session_id: currentSessionId,
//           }),
//         }
//       );

//       console.log("check hit close: ", responseStream)

//       if (!responseStream.ok) {
//         throw new Error(
//           `Server responded with status ${responseStream.status}`
//         );
//       }

//       const reader = responseStream.body.getReader();
//       const decoder = new TextDecoder();
//       let done = false;
//       let accumulatedResponse = "";
//       let displayedResponse = "";

//       // Create a buffer to hold partial content that might include special sections
//       let buffer = "";

//       while (!done) {
//         const { value, done: streamDone } = await reader.read();
//         done = streamDone;

//         if (value) {
//           const chunk = decoder.decode(value, { stream: true });

//           // Add to accumulated response for later processing
//           accumulatedResponse += chunk;

//           // Add to buffer for filtering
//           buffer += chunk;

//           // Strip References / followUp / Referenced Files HTML blocks
//           let cleanBuffer = stripSpecialSections(buffer);

//           // Update displayed response - only show parts we're sure are clean
//           // Keep buffer size reasonable by only keeping potential partial sections
//           if (cleanBuffer.length > 100) {
//             // Add most of the clean buffer to displayed response
//             const addToDisplay = cleanBuffer.slice(0, cleanBuffer.length - 50);
//             displayedResponse += addToDisplay;
//             console.log(displayedResponse, "displayedResponse");
//             // setResponseStream(displayedResponse);
//             // Keep only the last part in the buffer for continued checking
//             streamBufferRef.current = displayedResponse;
//             if (!streamFlushTimerRef.current) {
//               streamFlushTimerRef.current = setTimeout(() => {
//                 setResponseStream(streamBufferRef.current);
//                 streamFlushTimerRef.current = null;
//               }, 32);
//             }
//             buffer = cleanBuffer.slice(cleanBuffer.length - 50);
//           }

//           setLoading(false);
//           setQuestion("");
//         }
//       }

//       // Process the full complete response for extraction
//       const formattedResponse = accumulatedResponse
//         .replace(/answer:\s*/gi, "")
//         .trim();

//       // Extract references, suggested questions, and document details from the response
//       const extractedReferences = extractReferences(formattedResponse);
//       const extractedSuggestedQuestions = extractFollowUp(formattedResponse);
//       let extractedDocumentDetails = [];

//       const referencedFileEntries = extractReferencedFileNames(formattedResponse);
//       referencedFileEntries.forEach(({ fileName, score: fileScore }) => {
//         extractedDocumentDetails.push(fileName);
//         const encodedName = encodeURIComponent(fileName);
//         console.log(fileName, "→ check Documents inside the regex");
//         console.log(encodedName, "→ Document name in PDF");
//         fetch(`${process.env.REACT_APP_PORTAL_APP_BASE_URL}/admin/documents/getDocumentName?search=${encodedName}`, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             token: `${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
//           },
//         })
//           .then((res) => {
//             if (!res.ok) {
//               throw new Error(`API failed for document: ${fileName}`);
//             }
//             return res.json();
//           })
//           .then((data) => {
//             console.log("API result for", fileName, "→", data);
//             setDocumentInfo((prev) => [...prev, { documentName: fileName, score: fileScore, data }]);
//             setDocumentCount(extractedDocumentDetails.length);
//             if (extractedDocumentDetails.length > 0) {
//               setHelperButton(true);
//             }
//           })
//           .catch((err) => {
//             console.error("Error fetching document info:", err);
//           });
//       });

//       // Clean the full response one more time to ensure all special sections are removed
//       let cleanedFullResponse = stripSpecialSections(formattedResponse);

//       // Allow time for new message to render
//       setTimeout(() => {
//         if (chatContainerRef.current) {
//           chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
//         }
//       }, 100);
//       // Set the extracted data
//       setReferences(extractedReferences || "No references found.");
//       setSuggestedQuestions(extractedSuggestedQuestions);
//       setDocumentCount(extractedDocumentDetails.length);

//       console.log(extractedReferences, "extractedReferences check on handlestream");
//       // Show helper buttons if we have any of these features
//       if (
//         extractedReferences ||
//         extractedSuggestedQuestions.length > 0 ||
//         extractedDocumentDetails.length > 0
//       ) {
//         setHelperButton(true);
//       }

//       const newAiMessage = {
//         id: `ai-${Date.now()}`,
//         sender: "ai",
//         message: cleanedFullResponse,
//         ratingGiven: null // Add a field to track if rating was given
//       };

//       setConversation((prev) => [...prev, newAiMessage]);
//       hitRatingApi("Nothing", question, cleanedFullResponse, extractedDocumentDetails);
//       // Clear the stream display
//       setTimeout(() => {
//         setResponseStream("");
//       }, 50);
//     } catch (error) {
//       if (error.name === 'AbortError') {
//         console.log('Stream aborted');
//       } else {
//         console.error("Error fetching response:", error);
//       }
//     } finally {
//       setLoading(false);
//       setHelperLoader(false);
//       streamAbortControllerRef.current = null;
//       streamBufferRef.current = "";
//       if (streamFlushTimerRef.current) {
//         clearTimeout(streamFlushTimerRef.current);
//         streamFlushTimerRef.current = null;
//       }
//     }
//   };

//   const handleSend = async () => {
//     if (!question.trim()) return;
//     setLoading(true);
//     // Allow time for new message to render
//     setTimeout(() => {
//       if (chatContainerRef.current) {
//         chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
//       }
//     }, 100);
//     try {
//       SpeechRecognition.abortListening();
//       resetTranscript();
//       setQuestion("");
//       await handleStream();
//     } catch (error) {
//       console.error("Error executing API:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleStreamWithQuery = async (queryText, priorConversation) => {
//     setDocumentInfo([]);
//     setCurrentQuestion(queryText);
//     setResponseStream("");
//     setHelperButton(false);
//     setLoading(true);

//     const newUserMessage = {
//       id: `user-${Date.now()}`,
//       sender: "user",
//       message: queryText,
//     };

//     const updatedConversation = [...priorConversation, newUserMessage];
//     setConversation(updatedConversation);

//     try {
//       const controller = new AbortController();
//       streamAbortControllerRef.current = controller;

//       const res = await fetch(`${process.env.REACT_APP_BASEURL}/stream_response_html`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
//         },
//         signal: controller.signal,
//         body: JSON.stringify({
//           query: queryText,
//           chat_history: priorConversation.map((m) => m.message),
//           language: "en",
//           session_id: currentSessionId,
//         }),
//       });

//       if (!res.ok) throw new Error(`Server responded with status ${res.status}`);

//       const reader = res.body.getReader();
//       const decoder = new TextDecoder();
//       let done = false;
//       let accumulatedResponse = "";
//       let displayedResponse = "";
//       let buffer = "";

//       while (!done) {
//         const { value, done: streamDone } = await reader.read();
//         done = streamDone;
//         if (value) {
//           const chunk = decoder.decode(value, { stream: true });
//           accumulatedResponse += chunk;
//           buffer += chunk;

//           let cleanBuffer = stripSpecialSections(buffer);

//           if (cleanBuffer.length > 100) {
//             const addToDisplay = cleanBuffer.slice(0, cleanBuffer.length - 50);
//             displayedResponse += addToDisplay;
//             streamBufferRef.current = displayedResponse;
//             if (!streamFlushTimerRef.current) {
//               streamFlushTimerRef.current = setTimeout(() => {
//                 setResponseStream(streamBufferRef.current);
//                 streamFlushTimerRef.current = null;
//               }, 32);
//             }
//             buffer = cleanBuffer.slice(cleanBuffer.length - 50);
//           }
//           setLoading(false);
//           setQuestion("");
//         }
//       }

//       // ── Post-stream extraction (mirrors handleStream) ──────────────────────
//       const formattedResponse = accumulatedResponse.replace(/answer:\s*/gi, "").trim();

//       const extractedReferences = extractReferences(formattedResponse);
//       const extractedSuggestedQuestions = extractFollowUp(formattedResponse);
//       let extractedDocumentDetails = [];

//       const referencedFileEntries = extractReferencedFileNames(formattedResponse);
//       referencedFileEntries.forEach(({ fileName, score: fileScore }) => {
//         extractedDocumentDetails.push(fileName);
//         fetch(`${process.env.REACT_APP_PORTAL_APP_BASE_URL}/admin/documents/getDocumentName?search=${encodeURIComponent(fileName)}`, {
//           headers: { "Content-Type": "application/json", token: `${localStorage.getItem("token") || sessionStorage.getItem("token")}` },
//         }).then(r => r.json())
//           .then(data => {
//             setDocumentInfo(prev => [...prev, { documentName: fileName, score: fileScore, data }]);
//             setDocumentCount(extractedDocumentDetails.length);
//             if (extractedDocumentDetails.length > 0) setHelperButton(true);
//           }).catch(console.error);
//       });

//       let cleanedFull = stripSpecialSections(formattedResponse);

//       setReferences(extractedReferences || "No references found.");
//       setSuggestedQuestions(extractedSuggestedQuestions);
//       setDocumentCount(extractedDocumentDetails.length);
//       if (extractedReferences || extractedSuggestedQuestions.length > 0 || extractedDocumentDetails.length > 0)
//         setHelperButton(true);

//       const newAiMessage = { id: `ai-${Date.now()}`, sender: "ai", message: cleanedFull, ratingGiven: null };
//       setConversation(prev => [...prev, newAiMessage]);
//       hitRatingApi("Nothing", queryText, cleanedFull, extractedDocumentDetails);
//       setTimeout(() => setResponseStream(""), 50);
//       setTimeout(() => {
//         if (chatContainerRef.current)
//           chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
//       }, 100);
//     } catch (error) {
//       if (error.name !== 'AbortError') console.error("Error in handleStreamWithQuery:", error);
//     } finally {
//       setLoading(false);
//       setHelperLoader(false);
//       streamAbortControllerRef.current = null;
//       streamBufferRef.current = "";
//       if (streamFlushTimerRef.current) { clearTimeout(streamFlushTimerRef.current); streamFlushTimerRef.current = null; }
//     }
//   };

//   // ── Edit message handlers ───────────────────────────────────────────────────
//   const handleEditMessage = (msg) => {
//     setEditingMessageId(msg.id);
//     setEditingText(msg.message);
//   };

//   const handleCancelEdit = () => {
//     setEditingMessageId(null);
//     setEditingText("");
//   };

//   const handleSaveEdit = async () => {
//     if (!editingText.trim() || loading) return;

//     const msgIndex = conversation.findIndex((m) => m.id === editingMessageId);
//     if (msgIndex === -1) return;

//     // Truncate conversation up to (not including) the edited message
//     const truncated = conversation.slice(0, msgIndex);

//     setEditingMessageId(null);
//     setEditingText("");
//     setHelperButton(false);
//     setSuggestedQuestions([]);
//     setReferences("");
//     setResponseStream("");

//     await handleStreamWithQuery(editingText, truncated);
//   };

//   const stopStream = async () => {
//     try {
//       if (streamAbortControllerRef.current) {
//         try { streamAbortControllerRef.current.abort(); } catch (e) { /* ignore */ }
//       }
//       await fetch(`${process.env.REACT_APP_BASEURL}/stop_stream?sessionId=${currentSessionId}`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
//         },
//       });
//     } catch (err) {
//       console.error("Error calling stop_stream:", err);
//     } finally {
//       // If there's any partial streamed response visible, append it as the AI message
//       try {
//         if (responseStream && responseStream.trim()) {
//           const newAiMessage = {
//             id: `ai-${Date.now()}`,
//             sender: "ai",
//             message: responseStream.trim(),
//             ratingGiven: null
//           };
//           setConversation((prev) => [...prev, newAiMessage]);
//           // clear the transient stream display to avoid duplicates
//           setResponseStream("");
//         }
//       } catch (e) {
//         console.error('Error appending partial stream to conversation:', e);
//       }

//       setLoading(false);
//       streamAbortControllerRef.current = null;
//     }
//   };

//   const handleNavigateToReferences = () => {
//     setModalType("references");
//     setIsModalOpen(true);
//   };

//   const handleRefineSuggestions = () => {
//     setModalType("refine");
//     setIsModalOpen(true);
//   };

//   const handleEditDoc = () => {
//     setModalType("doc");
//     setIsModalOpen(true);
//   };

//   // Complete replacement for the handleSelectOption function with buffering
//   const handleSelectOption = async (selectedOption) => {

//     let displayedQuestion = selectedOption;
//     if (typeof selectedOption === "object") {
//       displayedQuestion = currentQuestion;
//       selectedOption =
//         currentQuestion + " in " + selectedOption.documentName + "?";
//     }

//     console.log(selectedOption, "final selectedOption");
//     setCurrentQuestion(displayedQuestion);
//     setLoading(true);
//     setIsModalOpen(false);
//     setResponseStream(null);
//     setSuggestedQuestions([]);
//     setHelperLoader(true);
//     setHelperButton(true);

//     const newUserMessage = {
//       id: `user-${Date.now()}`,
//       sender: "user",
//       message: selectedOption,
//     };

//     setConversation((prev) => [...prev, newUserMessage]);

//     try {
//       const baseUrl = process.env.REACT_APP_BASEURL;
//       const payload = {
//         query: selectedOption,
//         chat_history: conversation.map((msg) => msg.message),
//         language: "en",
//         session_id: currentSessionId,
//       };

//       const controller = new AbortController();
//       streamAbortControllerRef.current = controller;
//       const streamResponse = await fetch(`${baseUrl}/stream_response_html`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
//         },
//         signal: controller.signal,
//         body: JSON.stringify(payload),
//       });

//       if (!streamResponse.ok) {
//         throw new Error(`Stream API error: ${streamResponse.status}`);
//       }

//       const reader = streamResponse.body.getReader();
//       const decoder = new TextDecoder();
//       let done = false;
//       let fullStreamData = "";
//       let displayedResponse = "";
//       console.log(reader, "displayedResponse");

//       // Create a buffer to hold partial content that might include special sections
//       let buffer = "";

//       while (!done) {
//         const { value, done: streamDone } = await reader.read();
//         done = streamDone;

//         if (value) {
//           const chunk = decoder.decode(value, { stream: true });

//           // Add to full stream data for later processing
//           fullStreamData += chunk;

//           // Add to buffer for filtering
//           buffer += chunk;

//           // Strip References / followUp / Referenced Files HTML blocks
//           let cleanBuffer = stripSpecialSections(buffer);

//           // Update displayed response - only show parts we're sure are clean
//           // Keep buffer size reasonable by only keeping potential partial sections
//           if (cleanBuffer.length > 100) {
//             // Add most of the clean buffer to displayed response
//             const addToDisplay = cleanBuffer.slice(0, cleanBuffer.length - 50);
//             displayedResponse += addToDisplay;
//             // setResponseStream(displayedResponse);
//             streamBufferRef.current = displayedResponse;
//             if (!streamFlushTimerRef.current) {
//               streamFlushTimerRef.current = setTimeout(() => {
//                 setResponseStream(streamBufferRef.current);
//                 streamFlushTimerRef.current = null;
//               }, 32);
//             }

//             // Keep only the last part in the buffer for continued checking
//             buffer = cleanBuffer.slice(cleanBuffer.length - 50);
//           }
//           setLoading(false);
//         }
//       }

//       // Process the full complete response for extraction
//       // Extract references, suggested questions, and document details from the response
//       const extractedReferences = extractReferences(fullStreamData);
//       const extractedSuggestedQuestions = extractFollowUp(fullStreamData);
//       let extractedDocumentDetails = [];

//       const referencedFileEntries = extractReferencedFileNames(fullStreamData);
//       referencedFileEntries.forEach(({ fileName }) => {
//         extractedDocumentDetails.push(
//           `file_name:${fileName}, creation_date:${new Date().toISOString().split("T")[0]}`
//         );
//       });

//       // Clean the full response one more time to ensure all special sections are removed
//       let cleanedFullResponse = stripSpecialSections(fullStreamData);

//       // Set the extracted data
//       setReferences(extractedReferences || "No references found.");
//       setSuggestedQuestions(extractedSuggestedQuestions);
//       setDocumentCount(extractedDocumentDetails.length);

//       // Show helper buttons if we have any of these features
//       if (
//         extractedReferences ||
//         extractedSuggestedQuestions.length > 0 ||
//         extractedDocumentDetails.length > 0
//       ) {
//         setHelperButton(true);
//       }


//       const newAiMessage = {
//         id: `ai-${Date.now()}`,
//         sender: "ai",
//         message: cleanedFullResponse,
//         ratingGiven: null // Add a field to track if rating was given
//       };

//       setConversation((prev) => [...prev, newAiMessage]);
//       setHelperLoader(false);
//       hitRatingApi("Nothing", question, cleanedFullResponse, extractedDocumentDetails);
//       // Clear response stream to avoid duplication
//       setTimeout(() => {
//         setResponseStream("");
//       }, 50);
//     } catch (error) {
//       if (error.name === 'AbortError') {
//         console.log('Stream aborted (select option)');
//       } else {
//         console.error("Error fetching response:", error);
//       }
//     } finally {
//       setLoading(false);
//       setHelperLoader(false);
//       streamAbortControllerRef.current = null;
//       streamBufferRef.current = "";
//       if (streamFlushTimerRef.current) {
//         clearTimeout(streamFlushTimerRef.current);
//         streamFlushTimerRef.current = null;
//       }
//     }
//   };

//   // Function to handle rating submissions
//   const handleRating = async (messageId, ratingType) => {
//     try {
//       // Find the last question and this response
//       const messageIndex = conversation.findIndex(
//         (msg) => msg.id === messageId
//       );
//       if (messageIndex <= 0) return; // Safety check

//       // Get the last question (should be right before this response)
//       const lastQuestion = conversation[messageIndex - 1].message;
//       const thisResponse = conversation[messageIndex].message;

//       const response = await fetch(
//         `${process.env.REACT_APP_PORTAL_APP_BASE_URL}/admin/support/rating`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             token: `${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
//           },
//           body: JSON.stringify({
//             RatingType: ratingType,
//             question: lastQuestion,
//             answer: thisResponse,
//           }),
//         }
//       );

//       if (!response.ok) {
//         throw new Error(`Server responded with status ${response.status}`);
//       }

//       // Update conversation to mark the message as rated
//       setConversation((prev) =>
//         prev.map((msg) =>
//           msg.id === messageId ? { ...msg, ratingGiven: ratingType } : msg
//         )
//       );
//     } catch (error) {
//       console.error("Error submitting rating:", error);
//     }
//   };

//   const handleNewSession = useCallback(async () => {
//     sessionStorage.removeItem("conversation");
//     sessionStorage.removeItem("currentSessionId");
//     sessionStorage.removeItem("sessionNumber");

//     try {
//       const latestSessions = await fetchSessions();
//       const existingSessionIds = latestSessions.sessionIds || [];
//       const newSessionId = getNextAvailableSessionId(existingSessionIds);

//       const firstUserMessage = conversation.find(msg => msg.sender === "user");
//       const sessionName = firstUserMessage
//         ? (firstUserMessage.message.length > 30
//           ? firstUserMessage.message.substring(0, 30) + "..."
//           : firstUserMessage.message)
//         : `${newSessionId}`;

//       const newSession = {
//         id: newSessionId,
//         name: sessionName,
//         date: new Date().toLocaleString(),
//         conversation,
//       };

//       const updatedSessions = [newSession];
//       setLatestSession(newSessionId);
//       setCurrentSessionId(newSessionId);

//       setConversation([]);

//       sessionStorage.setItem("sessions", JSON.stringify(updatedSessions));
//       sessionStorage.setItem("conversation", JSON.stringify([]));
//       sessionStorage.setItem("sessionNumber", newSessionId);

//       // Reset helper state
//       setHelperButton(false);
//       setSuggestedQuestions([]);
//       setReferences("");
//       setResponseStream("");
//       setCurrentQuestion("");
//       setEditingMessageId(null);
//       setEditingText("");

//     } catch (error) {
//       console.error("Failed to handle new session:", error);
//     }
//   }, [
//     conversation,
//     setLatestSession,
//     setCurrentSessionId,
//     setConversation,
//     setHelperButton,
//     setSuggestedQuestions,
//     setReferences,
//     setResponseStream,
//     setCurrentQuestion,
//     fetchSessions
//   ]);

//   useEffect(() => {
//     const savedConversation = sessionStorage.getItem("conversation");
//     const savedSessionId = sessionStorage.getItem("sessionNumber");

//     if (savedConversation && savedSessionId) {
//       console.log(savedSessionId, "savedSessionId");

//       const parsedConversation = JSON.parse(savedConversation);
//       setConversation(parsedConversation);
//       setCurrentSessionId(savedSessionId);
//       setLatestSession(savedSessionId);

//       setTimeout(() => {
//         if (chatContainerRef.current) {
//           chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
//         }
//       }, 100);
//     } else {
//       const existingSessionIds = userSession.sessionIds || [];
//       const initialSessionId = getNextAvailableSessionId(existingSessionIds);

//       console.log(initialSessionId, "Initial session ID determined");
//       setCurrentSessionId(initialSessionId);
//       setLatestSession(initialSessionId);

//       // sessionStorage.setItem("sessionNumber", initialSessionId);
//       setSessionNumber(initialSessionId);
//     }

//   }, [isDev, userSession.sessionIds]);

//   useEffect(() => {
//     if ('permissions' in navigator) {
//       navigator.permissions.query({ name: 'microphone' })
//         .then(permissionStatus => {
//           setPermission(permissionStatus.state);
//           permissionStatus.onchange = () => {
//             setPermission(permissionStatus.state);
//           };
//         })
//         .catch(console.error);
//     }
//   }, []);

//   const requestMicrophonePermission = async () => {
//     try {
//       const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
//       stream.getTracks().forEach(track => track.stop());
//       setPermission('granted');
//       return true;
//     } catch (error) {
//       console.error('Microphone permission denied:', error);
//       setPermission('denied');
//       return false;
//     }
//   };

//   const handleClick = async () => {
//     if (!browserSupportsSpeechRecognition) {
//       alert('Your browser does not support speech recognition.');
//       return;
//     }
//     if (permission !== 'granted') {
//       const granted = await requestMicrophonePermission();
//       if (!granted) {
//         alert('Microphone permission is required for speech recognition.');
//         return;
//       }
//     }
//     if (listening) {
//       SpeechRecognition.abortListening();
//       resetTranscript();
//     } else {
//       startListening();
//     }
//   };

//   useEffect(() => {
//     if (transcript) {
//       setQuestion(transcript);
//     }
//   }, [transcript])

//   useEffect(() => {
//     fetchSessions();
//   }, [fetchSessions])

//   const isLastAIResponse = (msg) => {
//     const aiMessages = conversation.filter((item) => item.sender === "ai");
//     return (
//       aiMessages.length > 0 && msg.id === aiMessages[aiMessages.length - 1].id
//     );
//   };

//   useEffect(() => {
//     if (conversation?.length) {
//       const links = document.querySelectorAll('.responseStream_Main a');
//       links.forEach((link) => link.setAttribute('target', '_blank'));
//     }
//   }, [conversation]);

//   const kioskWidth = window.innerWidth;
//   // const kioskHeight = (window.screen && window.screen.height) ? window.screen.height : window.innerHeight;

//   const isUrdu = (text) => /[\u0600-\u06FF]/.test(text);

//   function isArabic(text) {
//     return /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/.test(text);
//   }

//   if (kioskWidth === 1080) {
//     return (
//       <div dir={dir} className="w-full">
//         <style>
//           {`
//             .custom-scrollbar::-webkit-scrollbar {
//               width: 5px;
//             }
            
//             .custom-scrollbar::-webkit-scrollbar-track {
//               background: #f1f1f1;
//               border-radius: 10px;
//               display: none;
//             }
            
//             .custom-scrollbar::-webkit-scrollbar-thumb {
//               background: #B03982;
//               border-radius: 10px;
//               display: none;
//             }
            
//             .custom-scrollbar.has-content::-webkit-scrollbar-track,
//             .custom-scrollbar.has-content::-webkit-scrollbar-thumb {
//               display: block;
//             }
            
//             .custom-scrollbar::-webkit-scrollbar-thumb:hover {
//               background: #8c2d66;
//             }

//             .whitespace-pre-line {
//               white-space: pre-line;
//             }
            
//             .active-rating {
//               color: #B03982 !important;
//             }
//           `}
//         </style>
//         <div className="w-full flex items-end justify-between">
//           {/* Middle Div - Main Chat Area */}
//           <div className="p-4 flex flex-col justify-between flex-1 max-w-[80%] ml-36 h-[90vh]">
//             {/* Top Section - Chat Messages */}
//             <div
//               className="flex flex-col gap-4 overflow-y-scroll custom-scrollbar"
//               ref={chatContainerRef}
//             >
//               {/* Header with new session handler */}
//               <Header dir={dir} onStartNewSession={handleNewSession} />

//               {/* Display session history */}
//               <div className="session-list mt-4">
//                 {latestSession && (
//                   <h2 className="text-lg font-bold">{latestSession}</h2>
//                 )}
//               </div>
//               {/* Greeting Card */}
//               {conversation.length === 0 && (
//                 <div className="w-full p-4 bg-gray-100 rounded-lg shadow-md">
//                   <p className="text-lg font-semibold text-gray-800 mb-2">
//                     {t("start_msg")}
//                   </p>
//                 </div>
//               )}

//               {/* Question and Response Area */}

//               <div className="space-y-4">
//                 {conversation.map((msg) => (
//                   <div
//                     key={msg.id}
//                     className={`flex w-full mb-4 ${msg.sender === "user" ? "justify-end" : "justify-start"}`}
//                   >
//                     {msg.sender === "user" ? (
//                       <div className={`flex items-start gap-4 w-full ${dir === 'rtl' ? 'flex-row-reverse' : ''}`}>
//                         {/* Avatar */}
//                         <div className="w-12 h-12 flex-shrink-0 cursor-pointer bg-gray-100 rounded-full border-4 border-[#B03982] flex items-center justify-center hover:shadow-lg transition-shadow">
//                           <span className="text-black text-[18px] font-semibold">
//                             {parsedDataOutScope?.name?.split(" ").map(w => w[0]).slice(0, 2).join("").toUpperCase()}
//                           </span>
//                         </div>

//                         {/* Message / Edit area */}
//                         <div className="flex-1 group relative">
//                           {editingMessageId === msg.id ? (
//                             /* ── Edit mode ── */
//                             <div className="flex flex-col gap-2">
//                               <textarea
//                                 autoFocus
//                                 value={editingText}
//                                 onChange={(e) => setEditingText(e.target.value)}
//                                 onKeyDown={(e) => {
//                                   if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); handleSaveEdit(); }
//                                   if (e.key === "Escape") handleCancelEdit();
//                                 }}
//                                 className="w-full p-3 rounded-lg border-2 border-[#B03982] focus:outline-none resize-none text-gray-900 bg-white shadow-md"
//                                 rows={3}
//                               />
//                               <div className="flex gap-2 justify-end">
//                                 <button
//                                   onClick={handleCancelEdit}
//                                   className="px-4 py-1.5 text-sm rounded-full border border-gray-400 text-gray-600 hover:bg-gray-100 transition-colors"
//                                 >
//                                   Cancel
//                                 </button>
//                                 <button
//                                   onClick={handleSaveEdit}
//                                   disabled={!editingText.trim() || loading}
//                                   className="px-4 py-1.5 text-sm rounded-full bg-[#B03982] text-white hover:bg-[#902F6A] disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
//                                 >
//                                   Send
//                                 </button>
//                               </div>
//                             </div>
//                           ) : (
//                             /* ── Display mode ── */
//                             <div className={`relative p-3 rounded-lg shadow-md bg-gray-100 text-gray-900 ${isUrdu(msg.message) || isArabic(msg.message) ? "text-right" : "text-left"}`}>
//                               <h3 className="text-base font-semibold break-words whitespace-normal pr-7">
//                                 {msg.message}
//                               </h3>
//                               {/* Pencil icon — visible on hover */}
//                               {!loading && (
//                                 <button
//                                   onClick={() => handleEditMessage(msg)}
//                                   className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity p-1 rounded-md hover:bg-gray-200 text-gray-500 hover:text-[#B03982]"
//                                   aria-label="Edit message"
//                                 >
//                                   <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
//                                     fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                                     <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
//                                     <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
//                                   </svg>
//                                 </button>
//                               )}
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                     ) : (
//                       <div
//                         className={`flex items-start w-full text-right gap-2`}
//                       >
//                         {/* gap-2 AI avatar */}
//                         {/* <div className="w-14 h-14 cursor-pointer rounded-full bg-white flex items-center justify-center"> */}
//                         <span className="w-12 h-12">
//                           <img src={nerdyicon} alt="AI" />
//                         </span>
//                         {/* </div> */}

//                         {/* AI response */}
//                         <div
//                           className={`flex-1 text-gray-700 break-words whitespace-normal ${isUrdu(msg.message) || isArabic(msg.message) ? "text-right" : "text-left"
//                             }`}
//                         >
//                           <ReactMarkdown
//                             className="responseStream_Main"
//                             children={msg.message}
//                             remarkPlugins={[remarkGfm]}
//                             rehypePlugins={[rehypeRaw]}
//                             unwrapDisallowed={false}
//                           // components={{
//                           //   a: ({ node, ...props }) => (
//                           //     <a
//                           //       {...props}
//                           //       target="_blank"
//                           //     />
//                           //   )
//                           // }}
//                           />

//                           {/* Rating buttons */}
//                           {isLastAIResponse(msg) && (
//                             <div className={`flex ${dir === 'rtl' ? 'justify-end' : ''} mt-2 space-x-2`}>
//                               <button
//                                 className={`text-gray-400 hover:text-black ml-2 ${msg.ratingGiven === "ThumbsUp" ? "active-rating" : ""}`}
//                                 onClick={() => handleRating(msg.id, "ThumbsUp")}
//                               >
//                                 <svg
//                                   xmlns="http://www.w3.org/2000/svg"
//                                   width="20"
//                                   height="20"
//                                   viewBox="0 0 24 24"
//                                   fill="none"
//                                   stroke="currentColor"
//                                   strokeWidth="2"
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                 >
//                                   <path d="M7 10v12" />
//                                   <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a3.13 3.13 0 0 1 3 3.88Z" />
//                                 </svg>
//                               </button>
//                               <button
//                                 className={`text-gray-400 hover:text-black ml-2 ${msg.ratingGiven === "ThumbsDown" ? "active-rating" : ""}`}
//                                 onClick={() => handleRating(msg.id, "ThumbsDown")}
//                               >
//                                 <svg
//                                   xmlns="http://www.w3.org/2000/svg"
//                                   width="20"
//                                   height="20"
//                                   viewBox="0 0 24 24"
//                                   fill="none"
//                                   stroke="currentColor"
//                                   strokeWidth="2"
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                 >
//                                   <path d="M17 14V2" />
//                                   <path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22h0a3.13 3.13 0 0 1-3-3.88Z" />
//                                 </svg>
//                               </button>
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 ))}
//                 <div>
//                   {loading && (
//                     <div className="flex items-center justify-center w-full">
//                       <img
//                         src={loadingGif}
//                         alt={t("loading")}
//                         className="w-60"
//                       />
//                     </div>
//                   )}

//                   {responseStream && (
//                     // <div className="w-full p-4 bg-gray-100 rounded-lg shadow-md">
//                     //   <ReactMarkdown
//                     //     className="text-gray-700 responseStream_Main"
//                     //     children={responseStream}
//                     //     remarkPlugins={[remarkGfm]}
//                     //     rehypePlugins={[rehypeRaw]}
//                     //     unwrapDisallowed={false}
//                     //   />
//                     // </div>
//                     <div className="flex items-start gap-4">
//                       <span className="w-12 h-12">
//                         <img src={nerdyicon} alt="AI" />
//                       </span>
//                       <div className="flex-1">
//                         <TaxInitialAllowance message={responseStream} />
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>



//             </div>
//             {/* Bottom Section - Input Area */}
//             <div className="relative w-full">
//               <ScrollButton helperButton={helperButton} chatContainerRef={chatContainerRef} />
//               <div>
//                 {helperButton && (
//                   <div className="flex justify-center gap-10 mb-10 mt-10">
//                     {references && references !== "No references found." && (
//                       <button
//                         onClick={handleNavigateToReferences}
//                         disabled={helperLoader}
//                         className={`px-4 py-2 border-2 border-[#B03982] rounded-3xl w-[11rem] ${helperLoader
//                           ? "bg-gray-300 text-gray-600 cursor-not-allowed"
//                           : "bg-transparent text-[#B03982] hover:bg-[#B03982] hover:text-white"
//                           }`}
//                       >
//                         {t("show_refernces")}
//                       </button>
//                     )}
//                     {suggestedQuestions.length > 0 && (
//                       <button
//                         onClick={handleRefineSuggestions}
//                         disabled={helperLoader}
//                         className={`px-4 py-2 rounded-3xl w-[11rem] ${helperLoader
//                           ? "bg-gray-300 text-gray-600 cursor-not-allowed"
//                           : "bg-[#B03982] text-white hover:bg-[#8c2d66]"
//                           }`}
//                       >
//                         {t("refine_it")}
//                       </button>
//                     )}
//                     {documentCount > 1 &&
//                       suggestedQuestions.length > 0 &&
//                       references &&
//                       references !== "No references found." && (
//                         <button
//                           onClick={handleEditDoc}
//                           disabled={helperLoader}
//                           className={`px-4 py-2 rounded-3xl w-[11rem] ${helperLoader
//                             ? "bg-gray-300 text-gray-600 cursor-not-allowed"
//                             : "bg-[#B03982] text-white hover:bg-[#8c2d66]"
//                             }`}
//                         >
//                           {t("select_document")}
//                         </button>
//                       )}
//                   </div>
//                 )}
//               </div>
//               <div className="flex items-center border border-gray-300 rounded-lg focus-within:ring-2 focus-within:ring-[#B03982] overflow-hidden min-h-[3.5rem]">
//                 <textarea
//                   value={question}
//                   onChange={(e) => setQuestion(e.target.value)}
//                   onKeyDown={(e) => {
//                     if (
//                       e.key === "Enter" &&
//                       !e.shiftKey &&
//                       question.trim() &&
//                       !loading
//                     ) {
//                       e.preventDefault();
//                       handleSend();
//                     }
//                   }}
//                   placeholder={t("ask_buddy")}
//                   disabled={loading}
//                   className="flex-grow h-full px-4 py-3 focus:outline-none resize-none disabled:cursor-not-allowed placeholder:text-gray-500"
//                   rows={1}
//                   style={{
//                     minHeight: '44px',
//                     maxHeight: '120px',
//                   }}
//                 />

//                 {/* Mic/Record Button */}
//                 <button
//                   onClick={handleClick}
//                   disabled={loading}
//                   className={`px-2 h-full flex items-center justify-center ${dir === 'rtl' ? 'border-l' : 'border-r'} border-gray-300 disabled:opacity-50 disabled:cursor-not-allowed`}
//                   aria-label={listening ? "Stop recording" : "Start recording"}
//                 >
//                   {listening ? (
//                     <div className="flex items-center justify-center">
//                       <div className="w-8 h-8 rounded-full bg-red-500 flex items-center justify-center animate-pulse">
//                         <div className="w-4 h-4 rounded-sm bg-white"></div>
//                       </div>
//                     </div>
//                   ) : (
//                     <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
//                       <svg className="w-8 h-8 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
//                         <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
//                         <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
//                       </svg>
//                     </div>
//                   )}
//                 </button>

//                 {/* Action Button (Send/Pause) */}
//                 <div className="mx-2">
//                   {(loading || responseStream) ? (
//                     <button
//                       onClick={stopStream}
//                       disabled={!(loading || responseStream)}
//                       className={`h-10 w-10 rounded-lg flex items-center justify-center text-white font-semibold bg-red-500 hover:bg-red-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors`}
//                       aria-label="Stop"
//                     >
//                       <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//                         <rect x="6" y="6" width="12" height="12" />
//                       </svg>
//                     </button>
//                   ) : (
//                     <button
//                       onClick={handleSend}
//                       disabled={!question.trim() || loading}
//                       className={`h-10 w-10 rounded-lg flex items-center justify-center text-white font-semibold transition-colors ${question.trim() && !loading
//                         ? "bg-[#B03982] hover:bg-[#902F6A]"
//                         : "bg-gray-300 cursor-not-allowed"
//                         }`}
//                       aria-label="Send message"
//                     >
//                       <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//                         <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
//                       </svg>
//                     </button>
//                   )}
//                 </div>
//               </div>
//               <p className="text-gray-500 text-center mt-3">NerdyBuddy can be inaccurate; please double check its responses.</p>
//             </div>
//           </div>
//           {/* Third Div - Character Image */}
//           <div className="p-4 pl-8 gap-36 flex flex-col">
//             <div className="w-[16rem] h-[20rem]">
//               <CharacterDisplay loading={loading} />
//               {/* <img src={Character} alt="Character" className="w-full h-full object-cover relative z-[-1]" /> */}
//             </div>
//           </div>
//           <Modal
//             isOpen={isModalOpen}
//             onClose={() => setIsModalOpen(false)}
//             type={modalType}
//           >
//             {modalType === "refine" && (
//               <Refine
//                 suggestedQuestions={suggestedQuestions}
//                 onSelectOption={handleSelectOption}
//                 onCloseModal={() => setIsModalOpen(false)}
//                 refineCount={refineCount}
//               />
//             )}
//             {modalType === "doc" && (
//               <Doc
//                 // documentDetails={documentDetails}
//                 documentDetails={documentInfo}
//                 onSelectOption={handleSelectOption}
//                 onCloseModal={() => setIsModalOpen(false)}
//                 dir={dir}
//               />
//             )}
//             {modalType === "references" && (
//               <References
//                 isOpen={isModalOpen}
//                 onClose={() => setIsModalOpen(false)}
//                 references={references}
//                 documentInfo={documentInfo}
//                 dir={dir}
//               />
//             )}
//           </Modal>
//         </div>
//       </div>
//     )
//   } else {
//     return (
//       <div dir={dir} className="min-h-full w-full flex" style={{ height: 'calc(100vh - 90px)' }}>
//         <style>
//           {`
//             .custom-scrollbar::-webkit-scrollbar {
//               width: 5px;
//             }
            
//             .custom-scrollbar::-webkit-scrollbar-track {
//               background: #f1f1f1;
//               border-radius: 10px;
//               display: none;
//             }
            
//             .custom-scrollbar::-webkit-scrollbar-thumb {
//               background: #B03982;
//               border-radius: 10px;
//               display: none;
//             }
            
//             .custom-scrollbar.has-content::-webkit-scrollbar-track,
//             .custom-scrollbar.has-content::-webkit-scrollbar-thumb {
//               display: block;
//             }
            
//             .custom-scrollbar::-webkit-scrollbar-thumb:hover {
//               background: #8c2d66;
//             }

//             .whitespace-pre-line {
//               white-space: pre-line;
//             }
            
//             .active-rating {
//               color: #B03982 !important;
//             }
//           `}
//         </style>
//         <div className="w-full flex items-end justify-between">
//           {/* First Div - Character Image */}
//           <div></div>

//           {/* Middle Div - Main Chat Area */}
//           <div className="h-screen p-4 flex flex-col justify-between flex-1 max-w-[60%] ml-20">
//             {/* Top Section - Chat Messages */}
//             <div
//               className="flex flex-col gap-4 mt-[3.5rem] h-full overflow-y-scroll custom-scrollbar"
//               ref={chatContainerRef}
//             >
//               {/* Header with new session handler */}
//               <Header dir={dir} onStartNewSession={handleNewSession} />

//               {/* Display session history */}
//               <div className="session-list mt-4">
//                 {latestSession && (
//                   <h2 className="text-lg font-bold">{latestSession}</h2>
//                 )}
//               </div>
//               {/* Greeting Card */}
//               {conversation.length === 0 && (
//                 <div className="w-full p-4 bg-gray-100 rounded-lg shadow-md">
//                   <p className="text-lg font-semibold text-gray-800 mb-2">
//                     {t("start_msg")}
//                   </p>
//                 </div>
//               )}

//               {/* Question and Response Area */}
//               <div className="space-y-4">
//                 {conversation.map((msg) => (
//                   <div
//                     key={msg.id}
//                     className={`flex w-full mb-4 ${msg.sender === "user" ? "justify-end" : "justify-start"}`}
//                   >
//                     {msg.sender === "user" ? (
//                       <div className={`flex items-start gap-4 w-full ${dir === 'rtl' ? 'flex-row-reverse' : ''}`}>
//                         {/* Avatar */}
//                         <div className="w-12 h-12 flex-shrink-0 cursor-pointer bg-gray-100 rounded-full border-4 border-[#B03982] flex items-center justify-center hover:shadow-lg transition-shadow">
//                           <span className="text-black text-[18px] font-semibold">
//                             {parsedDataOutScope?.name?.split(" ").map(w => w[0]).slice(0, 2).join("").toUpperCase()}
//                           </span>
//                         </div>

//                         {/* Message / Edit area */}
//                         <div className="flex-1 group relative">
//                           {editingMessageId === msg.id ? (
//                             /* ── Edit mode ── */
//                             <div className="flex flex-col gap-2">
//                               <textarea
//                                 autoFocus
//                                 value={editingText}
//                                 onChange={(e) => setEditingText(e.target.value)}
//                                 onKeyDown={(e) => {
//                                   if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); handleSaveEdit(); }
//                                   if (e.key === "Escape") handleCancelEdit();
//                                 }}
//                                 className="w-full p-3 rounded-lg border-2 border-[#B03982] focus:outline-none resize-none text-gray-900 bg-white shadow-md"
//                                 rows={3}
//                               />
//                               <div className="flex gap-2 justify-end">
//                                 <button
//                                   onClick={handleCancelEdit}
//                                   className="px-4 py-1.5 text-sm rounded-full border border-gray-400 text-gray-600 hover:bg-gray-100 transition-colors"
//                                 >
//                                   Cancel
//                                 </button>
//                                 <button
//                                   onClick={handleSaveEdit}
//                                   disabled={!editingText.trim() || loading}
//                                   className="px-4 py-1.5 text-sm rounded-full bg-[#B03982] text-white hover:bg-[#902F6A] disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
//                                 >
//                                   Send
//                                 </button>
//                               </div>
//                             </div>
//                           ) : (
//                             /* ── Display mode ── */
//                             <div className={`relative p-3 rounded-lg shadow-md bg-gray-100 text-gray-900 ${isUrdu(msg.message) || isArabic(msg.message) ? "text-right" : "text-left"}`}>
//                               <h3 className="text-base font-semibold break-words whitespace-normal pr-7">
//                                 {msg.message}
//                               </h3>
//                               {/* Pencil icon — visible on hover */}
//                               {!loading && (
//                                 <button
//                                   onClick={() => handleEditMessage(msg)}
//                                   className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity p-1 rounded-md hover:bg-gray-200 text-gray-500 hover:text-[#B03982]"
//                                   aria-label="Edit message"
//                                 >
//                                   <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
//                                     fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                                     <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
//                                     <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
//                                   </svg>
//                                 </button>
//                               )}
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                     ) : (
//                       <div
//                         className={`flex items-start w-full text-right gap-4`}
//                       >
//                         {/* gap-2 AI avatar */}
//                         {/* <div className="w-14 h-14 cursor-pointer rounded-full bg-white flex items-center justify-center"> */}
//                         <span className="w-12 h-12">
//                           <img src={nerdyicon} alt="AI" />
//                         </span>
//                         {/* </div> */}

//                         {/* AI response */}
//                         <div
//                           className={`flex-1 text-gray-700 break-words whitespace-normal ${isUrdu(msg.message) || isArabic(msg.message) ? "text-right" : "text-left"
//                             }`}
//                         >

//                           <TaxInitialAllowance message={msg.message} />

//                           {/* Rating buttons */}
//                           {isLastAIResponse(msg) && (
//                             <div className={`flex ${dir === 'rtl' ? 'justify-end' : ''} mt-2 space-x-2`}>
//                               <button
//                                 className={`text-gray-400 hover:text-black ml-2 ${msg.ratingGiven === "ThumbsUp" ? "active-rating" : ""}`}
//                                 onClick={() => handleRating(msg.id, "ThumbsUp")}
//                               >
//                                 <svg
//                                   xmlns="http://www.w3.org/2000/svg"
//                                   width="20"
//                                   height="20"
//                                   viewBox="0 0 24 24"
//                                   fill="none"
//                                   stroke="currentColor"
//                                   strokeWidth="2"
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                 >
//                                   <path d="M7 10v12" />
//                                   <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a3.13 3.13 0 0 1 3 3.88Z" />
//                                 </svg>
//                               </button>
//                               <button
//                                 className={`text-gray-400 hover:text-black ml-2 ${msg.ratingGiven === "ThumbsDown" ? "active-rating" : ""}`}
//                                 onClick={() => handleRating(msg.id, "ThumbsDown")}
//                               >
//                                 <svg
//                                   xmlns="http://www.w3.org/2000/svg"
//                                   width="20"
//                                   height="20"
//                                   viewBox="0 0 24 24"
//                                   fill="none"
//                                   stroke="currentColor"
//                                   strokeWidth="2"
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                 >
//                                   <path d="M17 14V2" />
//                                   <path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22h0a3.13 3.13 0 0 1-3-3.88Z" />
//                                 </svg>
//                               </button>
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 ))}
//                 <div>
//                   {loading && (
//                     <div className="flex items-center justify-center w-full">
//                       <img
//                         src={loadingGif}
//                         alt={t("loading")}
//                         className="w-60"
//                       />
//                     </div>
//                   )}

//                   {responseStream && (
//                     // <div className="w-full p-4 bg-gray-100 rounded-lg shadow-md">
//                     //   <ReactMarkdown
//                     //     className="text-gray-700 responseStream_Main"
//                     //     children={responseStream}
//                     //     remarkPlugins={[remarkGfm]}
//                     //     rehypePlugins={[rehypeRaw]}
//                     //     unwrapDisallowed={false}
//                     //   />
//                     // </div>
//                     <div className="flex items-start gap-4">
//                       <span className="w-12 h-12">
//                         <img src={nerdyicon} alt="AI" />
//                       </span>
//                       <div className="flex-1">
//                         <TaxInitialAllowance message={responseStream} />
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>

//             </div>
//             {/* Bottom Section - Input Area */}
//             <div className="relative w-full ">
//               <ScrollButton helperButton={helperButton} chatContainerRef={chatContainerRef} />
//               {helperButton && (
//                 <div className="flex justify-center gap-4 mb-4 mt-4">
//                   {references && references !== "No references found." && (
//                     <button
//                       onClick={handleNavigateToReferences}
//                       disabled={helperLoader}
//                       className={`px-4 py-2 border-2 border-[#B03982] rounded-full text-sm min-w-[110px] ${helperLoader
//                         ? "bg-gray-300 text-gray-600 cursor-not-allowed"
//                         : "bg-transparent text-[#B03982] hover:bg-[#B03982] hover:text-white"
//                         }`}
//                     >
//                       {t("show_refernces")}
//                     </button>
//                   )}

//                   {suggestedQuestions.length > 0 && (
//                     <button
//                       onClick={handleRefineSuggestions}
//                       disabled={helperLoader}
//                       className={`px-4 py-2 rounded-full text-sm min-w-[110px] ${helperLoader
//                         ? "bg-gray-300 text-gray-600 cursor-not-allowed"
//                         : "bg-[#B03982] text-white hover:bg-[#8c2d66]"
//                         }`}
//                     >
//                       {t("refine_it")}
//                     </button>
//                   )}

//                   {documentCount > 1 &&
//                     suggestedQuestions.length > 0 &&
//                     references &&
//                     references !== "No references found." && (
//                       <button
//                         onClick={handleEditDoc}
//                         disabled={helperLoader}
//                         className={`px-4 py-2 rounded-full text-sm min-w-[110px] ${helperLoader
//                           ? "bg-gray-300 text-gray-600 cursor-not-allowed"
//                           : "bg-[#B03982] text-white hover:bg-[#8c2d66]"
//                           }`}
//                       >
//                         {t("select_document")}
//                       </button>
//                     )}
//                 </div>
//               )}
//               <div className="flex items-center border border-gray-300 rounded-lg focus-within:ring-2 focus-within:ring-[#B03982] overflow-hidden min-h-[3.5rem]">
//                 <textarea
//                   value={question}
//                   onChange={(e) => setQuestion(e.target.value)}
//                   onKeyDown={(e) => {
//                     if (
//                       e.key === "Enter" &&
//                       !e.shiftKey &&
//                       question.trim() &&
//                       !loading
//                     ) {
//                       e.preventDefault();
//                       handleSend();
//                     }
//                   }}
//                   placeholder={t("ask_buddy")}
//                   disabled={loading}
//                   className="flex-grow h-full px-4 py-3 focus:outline-none resize-none disabled:cursor-not-allowed placeholder:text-gray-500"
//                   rows={1}
//                   style={{
//                     minHeight: '44px',
//                     maxHeight: '120px',
//                   }}
//                 />

//                 {/* Mic/Record Button */}
//                 <button
//                   onClick={handleClick}
//                   disabled={loading}
//                   className={`px-2 h-full flex items-center justify-center ${dir === 'rtl' ? 'border-l' : 'border-r'} border-gray-300 disabled:opacity-50 disabled:cursor-not-allowed`}
//                   aria-label={listening ? "Stop recording" : "Start recording"}
//                 >
//                   {listening ? (
//                     <div className="flex items-center justify-center">
//                       <div className="w-8 h-8 rounded-full bg-red-500 flex items-center justify-center animate-pulse">
//                         <div className="w-4 h-4 rounded-sm bg-white"></div>
//                       </div>
//                     </div>
//                   ) : (
//                     <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
//                       <svg className="w-8 h-8 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
//                         <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
//                         <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
//                       </svg>
//                     </div>
//                   )}
//                 </button>

//                 {/* Action Button (Send/Pause) */}
//                 <div className="mx-2">
//                   {(loading || responseStream) ? (
//                     <button
//                       onClick={stopStream}
//                       disabled={!(loading || responseStream)}
//                       className={`h-10 w-10 rounded-lg flex items-center justify-center text-white font-semibold bg-red-500 hover:bg-red-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors`}
//                       aria-label="Stop"
//                     >
//                       <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//                         <rect x="6" y="6" width="12" height="12" />
//                       </svg>
//                     </button>
//                   ) : (
//                     <button
//                       onClick={handleSend}
//                       disabled={!question.trim() || loading}
//                       className={`h-10 w-10 rounded-lg flex items-center justify-center text-white font-semibold transition-colors ${question.trim() && !loading
//                         ? "bg-[#B03982] hover:bg-[#902F6A]"
//                         : "bg-gray-300 cursor-not-allowed"
//                         }`}
//                       aria-label="Send message"
//                     >
//                       <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//                         <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
//                       </svg>
//                     </button>
//                   )}
//                 </div>
//               </div>
//               <p className="text-gray-500 text-center mt-2">NerdyBuddy can be inaccurate; please double check its responses.</p>
//             </div>
//           </div>

//           {/* Third Div - Character Image */}
//           <div className="p-4 pl-8 gap-36 flex flex-col">
//             <div className="w-[20rem] h-[26rem]">
//               <CharacterDisplay loading={loading} />
//               {/* <img src={Character} alt="Character" className="w-full h-full object-cover relative z-[-1]" /> */}
//             </div>
//           </div>
//           <Modal
//             isOpen={isModalOpen}
//             onClose={() => setIsModalOpen(false)}
//             type={modalType}
//           >
//             {modalType === "refine" && (
//               <Refine
//                 suggestedQuestions={suggestedQuestions}
//                 onSelectOption={handleSelectOption}
//                 onCloseModal={() => setIsModalOpen(false)}
//                 refineCount={refineCount}
//               />
//             )}
//             {modalType === "doc" && (
//               <Doc
//                 // documentDetails={documentDetails}
//                 documentDetails={documentInfo}
//                 onSelectOption={handleSelectOption}
//                 onCloseModal={() => setIsModalOpen(false)}
//                 dir={dir}
//               />
//             )}
//             {modalType === "references" && (
//               <References
//                 isOpen={isModalOpen}
//                 onClose={() => setIsModalOpen(false)}
//                 references={references}
//                 documentInfo={documentInfo}
//                 dir={dir}
//               />
//             )}
//           </Modal>
//         </div>
//         {/* <Recording /> */}
//         {/* <LiveChat /> */}
//       </div>
//     );
//   }

// };

// export default Home;

import React, { useState, useEffect, useRef, useCallback } from "react";
import Modal from "./Modal";
import Refine from "./refine";
import References from "./References";
import Doc from "./documentselector";
import loadingGif from "../assest/Loading.gif";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import Header from "../components/Header.js";
import ScrollButton from "./ScrollButton";
import rehypeRaw from 'rehype-raw';
import CharacterDisplay from "./CharacterDisplay.jsx";
import nerdyicon from "../assest/logo2.png";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import axios from "axios";
import { logout } from "../features/auth/authSlice.js";
import { useDispatch } from "react-redux";
// import LiveChat from "../components/LiveChat.jsx";
import parse from "html-react-parser";

const TaxInitialAllowance = ({ message }) => {
  console.log(message);
  return (
    <div className="prose max-w-none p-6 bg-white rounded-lg border border-gray-100 shadow">
      {parse(message)}
    </div>
  );
};

// ── HTML response section detection ─────────────────────────────────────────
// The backend streams HTML. Rather than assuming an exact tag/heading level
// (e.g. "must be <h3> immediately followed by <table>"), we locate a section
// by finding ANY tag whose text content is exactly "References", "followUp",
// or "Referenced Files" (colon optional), regardless of tag name, heading
// level, or attributes. Everything from that header up to the next header
// (or the end of the string) is treated as that section's content. This is
// tolerant of whatever markup shape the backend actually sends — <h2>, <h3>,
// <div>, <strong>, <p>, with or without class/id attributes, etc.
//
// Buttons (Show References / Refine It / Select Document) are only shown
// when the corresponding section was actually found in the response.

const SECTION_HEADER_PATTERN = /<([a-zA-Z][a-zA-Z0-9]*)\b[^>]*>\s*(References|followUp|Referenced Files)\s*:?\s*<\/\1>/gi;

// Finds every section header in the html and slices out the content that
// belongs to each one (from that header to the next header, or EOF).
// Returns e.g. { references: "<h3>References</h3><table>...", followup: "...", referencedfiles: "..." }
function locateSections(html) {
  const markers = [];
  let match;
  SECTION_HEADER_PATTERN.lastIndex = 0;
  while ((match = SECTION_HEADER_PATTERN.exec(html)) !== null) {
    const key = match[2].toLowerCase().replace(/\s+/g, "");
    markers.push({ key, start: match.index });
  }

  const sections = {};
  markers.forEach((marker, i) => {
    if (sections[marker.key]) return; // keep first occurrence only
    const end = i + 1 < markers.length ? markers[i + 1].start : html.length;
    sections[marker.key] = html.slice(marker.start, end);
  });

  return sections;
}

// Removes the References/followUp/Referenced-Files blocks from the HTML that
// gets rendered in the chat bubble. Safe to call on partial/streaming chunks —
// if no section header has arrived yet, this is a no-op.
function stripSpecialSections(html) {
  const sections = locateSections(html);
  let out = html;
  Object.values(sections).forEach((block) => {
    if (block) out = out.split(block).join("");
  });
  return out.trim();
}

// Pulls the raw References block (header + whatever follows it) out so it
// can be shown in the "References" modal.
function extractReferences(html) {
  const sections = locateSections(html);
  return sections.references ? sections.references.trim() : "";
}

// Pulls the follow-up question + numbered options out of the followUp block.
function extractFollowUp(html) {
  const sections = locateSections(html);
  const block = sections.followup;
  if (!block) return [];

  // Strip the header tag itself, keep only what follows it
  const headerMatch = block.match(/<([a-zA-Z][a-zA-Z0-9]*)\b[^>]*>\s*followUp\s*:?\s*<\/\1>/i);
  const rest = headerMatch ? block.slice(headerMatch[0].length) : block;

  // Convert <br> to newlines, then strip any remaining tags entirely so
  // formatting differences (e.g. wrapped in <p> per line) don't break parsing
  const content = rest
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/?[^>]+>/g, "")
    .trim();

  const questionMatch = content.match(/Question:\s*(.*?)(?:\n\d+\.|\n\n|$)/s);
  const mainQuestion = questionMatch ? questionMatch[1].trim() : "";

  const options = Array.from(
    content.matchAll(/\d+\.\s+(.*?)(?=\n\d+\.|\n*$)/gs),
    (m) => m[1].trim()
  ).filter(Boolean);

  if (mainQuestion && options.length > 0) {
    return [{ question: mainQuestion, options }];
  }
  return [];
}

// Pulls { fileName, score } pairs out of the Referenced Files list, no
// matter whether it's wrapped in <section>/<ul>/<li> or something looser —
// this just scans for <li>...</li> items anywhere inside the section block.
function extractReferencedFileNames(html) {
  const sections = locateSections(html);
  const block = sections.referencedfiles;
  const files = [];
  if (!block) return files;

  const itemPattern = /<li[^>]*>\s*([\s\S]*?)\s*<\/li>/gi;
  let m;
  while ((m = itemPattern.exec(block)) !== null) {
    const raw = m[1].replace(/<\/?[^>]+>/g, "").trim(); // strip any nested tags
    const lastColon = raw.lastIndexOf(":");
    if (lastColon === -1) continue;
    const fileName = raw.slice(0, lastColon).trim();
    const score = parseFloat(raw.slice(lastColon + 1).trim());
    if (fileName && !isNaN(score)) {
      files.push({ fileName, score });
    }
  }
  return files;
}

const Home = ({ dir }) => {

  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const chatContainerRef = useRef(null);
  const streamBufferRef = useRef("");
  const streamFlushTimerRef = useRef(null);

  const [question, setQuestion] = useState("");
  const [currentQuestion, setCurrentQuestion] = useState("");
  const [loading, setLoading] = useState(false);
  const [conversation, setConversation] = useState([]);
  const [references, setReferences] = useState("");
  const [suggestedQuestions, setSuggestedQuestions] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [responseStream, setResponseStream] = useState("");
  const [helperButton, setHelperButton] = useState(false);
  const [helperLoader, setHelperLoader] = useState(false);
  const [refineCount] = useState(0);
  const [documentCount, setDocumentCount] = useState(0);
  const [sessionNumber, setSessionNumber] = useState(null);
  const [latestSession, setLatestSession] = useState();
  const [currentSessionId, setCurrentSessionId] = useState(null);
  const [documentInfo, setDocumentInfo] = useState([]);
  const [userSession, setUserSession] = useState([]);

  const startListening = () => SpeechRecognition.startListening({ continuous: true, language: 'en-US', interimResults: true });
  const { transcript, listening, resetTranscript, browserSupportsSpeechRecognition } = useSpeechRecognition();
  const [permission, setPermission] = useState('prompt');

  // ── Edit message state ──────────────────────────────────────────────────────
  const [editingMessageId, setEditingMessageId] = useState(null);
  const [editingText, setEditingText] = useState("");

  const streamAbortControllerRef = useRef(null);

  const storedData = localStorage.getItem("profileData") || sessionStorage.getItem("profileData");
  let parsedDataOutScope;

  if (storedData) {
    const parsedData = JSON.parse(storedData);
    parsedDataOutScope = parsedData;
  }

  const isDev = process.env.NODE_ENV === 'development';

  const handleSignout = useCallback(() => {

    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("profileData");

    sessionStorage.removeItem("user");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("profileData");

    sessionStorage.removeItem("conversation");
    sessionStorage.removeItem("currentSessionId");
    sessionStorage.removeItem("sessionNumber");
    sessionStorage.removeItem("sessions");

    dispatch(logout())
    navigate("/login");

  }, [navigate, dispatch]);

  const hitRatingApi = async (ratingType, lastQuestion, thisResponse, referenceDoc) => {

    const response = await fetch(
      `${process.env.REACT_APP_PORTAL_APP_BASE_URL}/admin/support/rating`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: `${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          RatingType: ratingType,
          question: lastQuestion,
          answer: thisResponse,
          documentFileNames: referenceDoc,
        }),
      }
    );
    console.log(response);
  }

  const fetchSessions = useCallback(async () => {
    try {
      const baseUrl = process.env.REACT_APP_BASEURL;
      const token = localStorage.getItem("token") || sessionStorage.getItem("token");

      if (!token) {

        localStorage.removeItem("user");
        localStorage.removeItem("token");
        localStorage.removeItem("profileData");

        sessionStorage.removeItem("user");
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("profileData");

        sessionStorage.removeItem("conversation");
        sessionStorage.removeItem("currentSessionId");
        sessionStorage.removeItem("sessionNumber");
        sessionStorage.removeItem("sessions");

        dispatch(logout())
        navigate("/login");

      }

      const response = await axios.get(`${baseUrl}/get_user_sessions`, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });

      const data = response.data;
      const apiResponse = {
        sessionIds: data?.sessions?.map(session => session.sessionId)
      };

      console.log(apiResponse, "Transformed API Response");
      setUserSession(apiResponse);
      return apiResponse;
    } catch (err) {
      if (err?.response?.status === 401) {
        handleSignout();
      }
      console.log("Failed to fetch sessions:", err);
      return [];
    }
  }, [navigate, dispatch, handleSignout]);

  const getNextAvailableSessionId = (existingSessionIds) => {
    let i = 1;
    let newId;
    do {
      newId = `Session-${i}`;
      i++;
    } while (existingSessionIds.includes(newId));
    return newId;
  };

  useEffect(() => {
    // Only update the sessionStorage if we have a valid current session ID
    if (currentSessionId && conversation.length > 0) {
      const savedSessions = JSON.parse(sessionStorage.getItem("sessions")) || [];

      // Find the index of the current session in the array
      const sessionIndex = savedSessions.findIndex(session => session.id === currentSessionId);

      if (sessionIndex >= 0) {
        // Update the existing session
        savedSessions[sessionIndex] = {
          ...savedSessions[sessionIndex],
          conversation
        };
      } else {
        // Add a new session
        savedSessions.push({
          id: currentSessionId,
          name: latestSession || `Session ${sessionNumber}`,
          date: new Date().toLocaleString(),
          conversation
        });
      }
      sessionStorage.setItem("sessions", JSON.stringify(savedSessions));
      sessionStorage.setItem("conversation", JSON.stringify(conversation));
    }
  }, [conversation, currentSessionId, latestSession, sessionNumber]);

  const handleStream = async () => {

    if (!question.trim()) return;

    setDocumentInfo([]);
    setCurrentQuestion(question);
    setResponseStream("");
    setHelperButton(false);
    setLoading(true);

    const newUserMessage = {
      id: `user-${Date.now()}`,
      sender: "user",
      message: question,
    };

    setConversation((prev) => [...prev, newUserMessage]);

    try {

      console.log("check hit open:")
      const controller = new AbortController();
      streamAbortControllerRef.current = controller;
      const responseStream = await fetch(
        `${process.env.REACT_APP_BASEURL}/stream_response_html`,

        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
          },
          signal: controller.signal,
          body: JSON.stringify({
            query: question,
            chat_history: conversation.map((msg) => msg.message),
            language: "en",
            session_id: currentSessionId,
          }),
        }
      );

      console.log("check hit close: ", responseStream)

      if (!responseStream.ok) {
        throw new Error(
          `Server responded with status ${responseStream.status}`
        );
      }

      const reader = responseStream.body.getReader();
      const decoder = new TextDecoder();
      let done = false;
      let accumulatedResponse = "";
      let displayedResponse = "";

      // Create a buffer to hold partial content that might include special sections
      let buffer = "";

      while (!done) {
        const { value, done: streamDone } = await reader.read();
        done = streamDone;

        if (value) {
          const chunk = decoder.decode(value, { stream: true });

          // Add to accumulated response for later processing
          accumulatedResponse += chunk;

          // Add to buffer for filtering
          buffer += chunk;

          // Strip References / followUp / Referenced Files HTML blocks
          let cleanBuffer = stripSpecialSections(buffer);

          // Update displayed response - only show parts we're sure are clean
          // Keep buffer size reasonable by only keeping potential partial sections
          if (cleanBuffer.length > 100) {
            // Add most of the clean buffer to displayed response
            const addToDisplay = cleanBuffer.slice(0, cleanBuffer.length - 50);
            displayedResponse += addToDisplay;
            console.log(displayedResponse, "displayedResponse");
            // setResponseStream(displayedResponse);
            // Keep only the last part in the buffer for continued checking
            streamBufferRef.current = displayedResponse;
            if (!streamFlushTimerRef.current) {
              streamFlushTimerRef.current = setTimeout(() => {
                setResponseStream(streamBufferRef.current);
                streamFlushTimerRef.current = null;
              }, 32);
            }
            buffer = cleanBuffer.slice(cleanBuffer.length - 50);
          }

          setLoading(false);
          setQuestion("");
        }
      }

      // Process the full complete response for extraction
      const formattedResponse = accumulatedResponse
        .replace(/answer:\s*/gi, "")
        .trim();

      // Extract references, suggested questions, and document details from the response
      const extractedReferences = extractReferences(formattedResponse);
      const extractedSuggestedQuestions = extractFollowUp(formattedResponse);
      let extractedDocumentDetails = [];

      const referencedFileEntries = extractReferencedFileNames(formattedResponse);
      referencedFileEntries.forEach(({ fileName, score: fileScore }) => {
        extractedDocumentDetails.push(fileName);
        const encodedName = encodeURIComponent(fileName);
        console.log(fileName, "→ check Documents inside the regex");
        console.log(encodedName, "→ Document name in PDF");
        fetch(`${process.env.REACT_APP_PORTAL_APP_BASE_URL}/admin/documents/getDocumentName?search=${encodedName}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            token: `${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
          },
        })
          .then((res) => {
            if (!res.ok) {
              throw new Error(`API failed for document: ${fileName}`);
            }
            return res.json();
          })
          .then((data) => {
            console.log("API result for", fileName, "→", data);
            setDocumentInfo((prev) => [...prev, { documentName: fileName, score: fileScore, data }]);
            setDocumentCount(extractedDocumentDetails.length);
            if (extractedDocumentDetails.length > 0) {
              setHelperButton(true);
            }
          })
          .catch((err) => {
            console.error("Error fetching document info:", err);
          });
      });

      // Clean the full response one more time to ensure all special sections are removed
      let cleanedFullResponse = stripSpecialSections(formattedResponse);

      // Allow time for new message to render
      setTimeout(() => {
        if (chatContainerRef.current) {
          chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
      }, 100);
      // Set the extracted data
      setReferences(extractedReferences || "No references found.");
      setSuggestedQuestions(extractedSuggestedQuestions);
      setDocumentCount(extractedDocumentDetails.length);

      console.log(extractedReferences, "extractedReferences check on handlestream");
      // Show helper buttons if we have any of these features
      if (
        extractedReferences ||
        extractedSuggestedQuestions.length > 0 ||
        extractedDocumentDetails.length > 0
      ) {
        setHelperButton(true);
      }

      const newAiMessage = {
        id: `ai-${Date.now()}`,
        sender: "ai",
        message: cleanedFullResponse,
        ratingGiven: null // Add a field to track if rating was given
      };

      setConversation((prev) => [...prev, newAiMessage]);
      hitRatingApi("Nothing", question, cleanedFullResponse, extractedDocumentDetails);
      // Clear the stream display
      setTimeout(() => {
        setResponseStream("");
      }, 50);
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('Stream aborted');
      } else {
        console.error("Error fetching response:", error);
      }
    } finally {
      setLoading(false);
      setHelperLoader(false);
      streamAbortControllerRef.current = null;
      streamBufferRef.current = "";
      if (streamFlushTimerRef.current) {
        clearTimeout(streamFlushTimerRef.current);
        streamFlushTimerRef.current = null;
      }
    }
  };

  const handleSend = async () => {
    if (!question.trim()) return;
    setLoading(true);
    // Allow time for new message to render
    setTimeout(() => {
      if (chatContainerRef.current) {
        chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
      }
    }, 100);
    try {
      SpeechRecognition.abortListening();
      resetTranscript();
      setQuestion("");
      await handleStream();
    } catch (error) {
      console.error("Error executing API:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleStreamWithQuery = async (queryText, priorConversation) => {
    setDocumentInfo([]);
    setCurrentQuestion(queryText);
    setResponseStream("");
    setHelperButton(false);
    setLoading(true);

    const newUserMessage = {
      id: `user-${Date.now()}`,
      sender: "user",
      message: queryText,
    };

    const updatedConversation = [...priorConversation, newUserMessage];
    setConversation(updatedConversation);

    try {
      const controller = new AbortController();
      streamAbortControllerRef.current = controller;

      const res = await fetch(`${process.env.REACT_APP_BASEURL}/stream_response_html`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
        },
        signal: controller.signal,
        body: JSON.stringify({
          query: queryText,
          chat_history: priorConversation.map((m) => m.message),
          language: "en",
          session_id: currentSessionId,
        }),
      });

      if (!res.ok) throw new Error(`Server responded with status ${res.status}`);

      const reader = res.body.getReader();
      const decoder = new TextDecoder();
      let done = false;
      let accumulatedResponse = "";
      let displayedResponse = "";
      let buffer = "";

      while (!done) {
        const { value, done: streamDone } = await reader.read();
        done = streamDone;
        if (value) {
          const chunk = decoder.decode(value, { stream: true });
          accumulatedResponse += chunk;
          buffer += chunk;

          let cleanBuffer = stripSpecialSections(buffer);

          if (cleanBuffer.length > 100) {
            const addToDisplay = cleanBuffer.slice(0, cleanBuffer.length - 50);
            displayedResponse += addToDisplay;
            streamBufferRef.current = displayedResponse;
            if (!streamFlushTimerRef.current) {
              streamFlushTimerRef.current = setTimeout(() => {
                setResponseStream(streamBufferRef.current);
                streamFlushTimerRef.current = null;
              }, 32);
            }
            buffer = cleanBuffer.slice(cleanBuffer.length - 50);
          }
          setLoading(false);
          setQuestion("");
        }
      }

      // ── Post-stream extraction (mirrors handleStream) ──────────────────────
      const formattedResponse = accumulatedResponse.replace(/answer:\s*/gi, "").trim();

      const extractedReferences = extractReferences(formattedResponse);
      const extractedSuggestedQuestions = extractFollowUp(formattedResponse);
      let extractedDocumentDetails = [];

      const referencedFileEntries = extractReferencedFileNames(formattedResponse);
      referencedFileEntries.forEach(({ fileName, score: fileScore }) => {
        extractedDocumentDetails.push(fileName);
        fetch(`${process.env.REACT_APP_PORTAL_APP_BASE_URL}/admin/documents/getDocumentName?search=${encodeURIComponent(fileName)}`, {
          headers: { "Content-Type": "application/json", token: `${localStorage.getItem("token") || sessionStorage.getItem("token")}` },
        }).then(r => r.json())
          .then(data => {
            setDocumentInfo(prev => [...prev, { documentName: fileName, score: fileScore, data }]);
            setDocumentCount(extractedDocumentDetails.length);
            if (extractedDocumentDetails.length > 0) setHelperButton(true);
          }).catch(console.error);
      });

      let cleanedFull = stripSpecialSections(formattedResponse);

      setReferences(extractedReferences || "No references found.");
      setSuggestedQuestions(extractedSuggestedQuestions);
      setDocumentCount(extractedDocumentDetails.length);
      if (extractedReferences || extractedSuggestedQuestions.length > 0 || extractedDocumentDetails.length > 0)
        setHelperButton(true);

      const newAiMessage = { id: `ai-${Date.now()}`, sender: "ai", message: cleanedFull, ratingGiven: null };
      setConversation(prev => [...prev, newAiMessage]);
      hitRatingApi("Nothing", queryText, cleanedFull, extractedDocumentDetails);
      setTimeout(() => setResponseStream(""), 50);
      setTimeout(() => {
        if (chatContainerRef.current)
          chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
      }, 100);
    } catch (error) {
      if (error.name !== 'AbortError') console.error("Error in handleStreamWithQuery:", error);
    } finally {
      setLoading(false);
      setHelperLoader(false);
      streamAbortControllerRef.current = null;
      streamBufferRef.current = "";
      if (streamFlushTimerRef.current) { clearTimeout(streamFlushTimerRef.current); streamFlushTimerRef.current = null; }
    }
  };

  // ── Edit message handlers ───────────────────────────────────────────────────
  const handleEditMessage = (msg) => {
    setEditingMessageId(msg.id);
    setEditingText(msg.message);
  };

  const handleCancelEdit = () => {
    setEditingMessageId(null);
    setEditingText("");
  };

  const handleSaveEdit = async () => {
    if (!editingText.trim() || loading) return;

    const msgIndex = conversation.findIndex((m) => m.id === editingMessageId);
    if (msgIndex === -1) return;

    // Truncate conversation up to (not including) the edited message
    const truncated = conversation.slice(0, msgIndex);

    setEditingMessageId(null);
    setEditingText("");
    setHelperButton(false);
    setSuggestedQuestions([]);
    setReferences("");
    setResponseStream("");

    await handleStreamWithQuery(editingText, truncated);
  };

  const stopStream = async () => {
    try {
      if (streamAbortControllerRef.current) {
        try { streamAbortControllerRef.current.abort(); } catch (e) { /* ignore */ }
      }
      await fetch(`${process.env.REACT_APP_BASEURL}/stop_stream?sessionId=${currentSessionId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
        },
      });
    } catch (err) {
      console.error("Error calling stop_stream:", err);
    } finally {
      // If there's any partial streamed response visible, append it as the AI message
      try {
        if (responseStream && responseStream.trim()) {
          const newAiMessage = {
            id: `ai-${Date.now()}`,
            sender: "ai",
            message: responseStream.trim(),
            ratingGiven: null
          };
          setConversation((prev) => [...prev, newAiMessage]);
          // clear the transient stream display to avoid duplicates
          setResponseStream("");
        }
      } catch (e) {
        console.error('Error appending partial stream to conversation:', e);
      }

      setLoading(false);
      streamAbortControllerRef.current = null;
    }
  };

  const handleNavigateToReferences = () => {
    setModalType("references");
    setIsModalOpen(true);
  };

  const handleRefineSuggestions = () => {
    setModalType("refine");
    setIsModalOpen(true);
  };

  const handleEditDoc = () => {
    setModalType("doc");
    setIsModalOpen(true);
  };

  // Complete replacement for the handleSelectOption function with buffering
  const handleSelectOption = async (selectedOption) => {

    let displayedQuestion = selectedOption;
    if (typeof selectedOption === "object") {
      displayedQuestion = currentQuestion;
      selectedOption =
        currentQuestion + " in " + selectedOption.documentName + "?";
    }

    console.log(selectedOption, "final selectedOption");
    setCurrentQuestion(displayedQuestion);
    setLoading(true);
    setIsModalOpen(false);
    setResponseStream(null);
    setSuggestedQuestions([]);
    setHelperLoader(true);
    setHelperButton(true);

    const newUserMessage = {
      id: `user-${Date.now()}`,
      sender: "user",
      message: selectedOption,
    };

    setConversation((prev) => [...prev, newUserMessage]);

    try {
      const baseUrl = process.env.REACT_APP_BASEURL;
      const payload = {
        query: selectedOption,
        chat_history: conversation.map((msg) => msg.message),
        language: "en",
        session_id: currentSessionId,
      };

      const controller = new AbortController();
      streamAbortControllerRef.current = controller;
      const streamResponse = await fetch(`${baseUrl}/stream_response_html`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
        },
        signal: controller.signal,
        body: JSON.stringify(payload),
      });

      if (!streamResponse.ok) {
        throw new Error(`Stream API error: ${streamResponse.status}`);
      }

      const reader = streamResponse.body.getReader();
      const decoder = new TextDecoder();
      let done = false;
      let fullStreamData = "";
      let displayedResponse = "";
      console.log(reader, "displayedResponse");

      // Create a buffer to hold partial content that might include special sections
      let buffer = "";

      while (!done) {
        const { value, done: streamDone } = await reader.read();
        done = streamDone;

        if (value) {
          const chunk = decoder.decode(value, { stream: true });

          // Add to full stream data for later processing
          fullStreamData += chunk;

          // Add to buffer for filtering
          buffer += chunk;

          // Strip References / followUp / Referenced Files HTML blocks
          let cleanBuffer = stripSpecialSections(buffer);

          // Update displayed response - only show parts we're sure are clean
          // Keep buffer size reasonable by only keeping potential partial sections
          if (cleanBuffer.length > 100) {
            // Add most of the clean buffer to displayed response
            const addToDisplay = cleanBuffer.slice(0, cleanBuffer.length - 50);
            displayedResponse += addToDisplay;
            // setResponseStream(displayedResponse);
            streamBufferRef.current = displayedResponse;
            if (!streamFlushTimerRef.current) {
              streamFlushTimerRef.current = setTimeout(() => {
                setResponseStream(streamBufferRef.current);
                streamFlushTimerRef.current = null;
              }, 32);
            }

            // Keep only the last part in the buffer for continued checking
            buffer = cleanBuffer.slice(cleanBuffer.length - 50);
          }
          setLoading(false);
        }
      }

      // Process the full complete response for extraction
      // Extract references, suggested questions, and document details from the response
      const extractedReferences = extractReferences(fullStreamData);
      const extractedSuggestedQuestions = extractFollowUp(fullStreamData);
      let extractedDocumentDetails = [];

      const referencedFileEntries = extractReferencedFileNames(fullStreamData);
      referencedFileEntries.forEach(({ fileName }) => {
        extractedDocumentDetails.push(
          `file_name:${fileName}, creation_date:${new Date().toISOString().split("T")[0]}`
        );
      });

      // Clean the full response one more time to ensure all special sections are removed
      let cleanedFullResponse = stripSpecialSections(fullStreamData);

      // Set the extracted data
      setReferences(extractedReferences || "No references found.");
      setSuggestedQuestions(extractedSuggestedQuestions);
      setDocumentCount(extractedDocumentDetails.length);

      // Show helper buttons if we have any of these features
      if (
        extractedReferences ||
        extractedSuggestedQuestions.length > 0 ||
        extractedDocumentDetails.length > 0
      ) {
        setHelperButton(true);
      }


      const newAiMessage = {
        id: `ai-${Date.now()}`,
        sender: "ai",
        message: cleanedFullResponse,
        ratingGiven: null // Add a field to track if rating was given
      };

      setConversation((prev) => [...prev, newAiMessage]);
      setHelperLoader(false);
      hitRatingApi("Nothing", question, cleanedFullResponse, extractedDocumentDetails);
      // Clear response stream to avoid duplication
      setTimeout(() => {
        setResponseStream("");
      }, 50);
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('Stream aborted (select option)');
      } else {
        console.error("Error fetching response:", error);
      }
    } finally {
      setLoading(false);
      setHelperLoader(false);
      streamAbortControllerRef.current = null;
      streamBufferRef.current = "";
      if (streamFlushTimerRef.current) {
        clearTimeout(streamFlushTimerRef.current);
        streamFlushTimerRef.current = null;
      }
    }
  };

  // Function to handle rating submissions
  const handleRating = async (messageId, ratingType) => {
    try {
      // Find the last question and this response
      const messageIndex = conversation.findIndex(
        (msg) => msg.id === messageId
      );
      if (messageIndex <= 0) return; // Safety check

      // Get the last question (should be right before this response)
      const lastQuestion = conversation[messageIndex - 1].message;
      const thisResponse = conversation[messageIndex].message;

      const response = await fetch(
        `${process.env.REACT_APP_PORTAL_APP_BASE_URL}/admin/support/rating`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token: `${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
          },
          body: JSON.stringify({
            RatingType: ratingType,
            question: lastQuestion,
            answer: thisResponse,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`Server responded with status ${response.status}`);
      }

      // Update conversation to mark the message as rated
      setConversation((prev) =>
        prev.map((msg) =>
          msg.id === messageId ? { ...msg, ratingGiven: ratingType } : msg
        )
      );
    } catch (error) {
      console.error("Error submitting rating:", error);
    }
  };

  const handleNewSession = useCallback(async () => {
    sessionStorage.removeItem("conversation");
    sessionStorage.removeItem("currentSessionId");
    sessionStorage.removeItem("sessionNumber");

    try {
      const latestSessions = await fetchSessions();
      const existingSessionIds = latestSessions.sessionIds || [];
      const newSessionId = getNextAvailableSessionId(existingSessionIds);

      const firstUserMessage = conversation.find(msg => msg.sender === "user");
      const sessionName = firstUserMessage
        ? (firstUserMessage.message.length > 30
          ? firstUserMessage.message.substring(0, 30) + "..."
          : firstUserMessage.message)
        : `${newSessionId}`;

      const newSession = {
        id: newSessionId,
        name: sessionName,
        date: new Date().toLocaleString(),
        conversation,
      };

      const updatedSessions = [newSession];
      setLatestSession(newSessionId);
      setCurrentSessionId(newSessionId);

      setConversation([]);

      sessionStorage.setItem("sessions", JSON.stringify(updatedSessions));
      sessionStorage.setItem("conversation", JSON.stringify([]));
      sessionStorage.setItem("sessionNumber", newSessionId);

      // Reset helper state
      setHelperButton(false);
      setSuggestedQuestions([]);
      setReferences("");
      setResponseStream("");
      setCurrentQuestion("");
      setEditingMessageId(null);
      setEditingText("");

    } catch (error) {
      console.error("Failed to handle new session:", error);
    }
  }, [
    conversation,
    setLatestSession,
    setCurrentSessionId,
    setConversation,
    setHelperButton,
    setSuggestedQuestions,
    setReferences,
    setResponseStream,
    setCurrentQuestion,
    fetchSessions
  ]);

  useEffect(() => {
    const savedConversation = sessionStorage.getItem("conversation");
    const savedSessionId = sessionStorage.getItem("sessionNumber");

    if (savedConversation && savedSessionId) {
      console.log(savedSessionId, "savedSessionId");

      const parsedConversation = JSON.parse(savedConversation);
      setConversation(parsedConversation);
      setCurrentSessionId(savedSessionId);
      setLatestSession(savedSessionId);

      setTimeout(() => {
        if (chatContainerRef.current) {
          chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
      }, 100);
    } else {
      const existingSessionIds = userSession.sessionIds || [];
      const initialSessionId = getNextAvailableSessionId(existingSessionIds);

      console.log(initialSessionId, "Initial session ID determined");
      setCurrentSessionId(initialSessionId);
      setLatestSession(initialSessionId);

      // sessionStorage.setItem("sessionNumber", initialSessionId);
      setSessionNumber(initialSessionId);
    }

  }, [isDev, userSession.sessionIds]);

  useEffect(() => {
    if ('permissions' in navigator) {
      navigator.permissions.query({ name: 'microphone' })
        .then(permissionStatus => {
          setPermission(permissionStatus.state);
          permissionStatus.onchange = () => {
            setPermission(permissionStatus.state);
          };
        })
        .catch(console.error);
    }
  }, []);

  const requestMicrophonePermission = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      stream.getTracks().forEach(track => track.stop());
      setPermission('granted');
      return true;
    } catch (error) {
      console.error('Microphone permission denied:', error);
      setPermission('denied');
      return false;
    }
  };

  const handleClick = async () => {
    if (!browserSupportsSpeechRecognition) {
      alert('Your browser does not support speech recognition.');
      return;
    }
    if (permission !== 'granted') {
      const granted = await requestMicrophonePermission();
      if (!granted) {
        alert('Microphone permission is required for speech recognition.');
        return;
      }
    }
    if (listening) {
      SpeechRecognition.abortListening();
      resetTranscript();
    } else {
      startListening();
    }
  };

  useEffect(() => {
    if (transcript) {
      setQuestion(transcript);
    }
  }, [transcript])

  useEffect(() => {
    fetchSessions();
  }, [fetchSessions])

  const isLastAIResponse = (msg) => {
    const aiMessages = conversation.filter((item) => item.sender === "ai");
    return (
      aiMessages.length > 0 && msg.id === aiMessages[aiMessages.length - 1].id
    );
  };

  useEffect(() => {
    if (conversation?.length) {
      const links = document.querySelectorAll('.responseStream_Main a');
      links.forEach((link) => link.setAttribute('target', '_blank'));
    }
  }, [conversation]);

  const kioskWidth = window.innerWidth;
  // const kioskHeight = (window.screen && window.screen.height) ? window.screen.height : window.innerHeight;

  const isUrdu = (text) => /[\u0600-\u06FF]/.test(text);

  function isArabic(text) {
    return /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/.test(text);
  }

  if (kioskWidth === 1080) {
    return (
      <div dir={dir} className="w-full">
        <style>
          {`
            .custom-scrollbar::-webkit-scrollbar {
              width: 5px;
            }
            
            .custom-scrollbar::-webkit-scrollbar-track {
              background: #f1f1f1;
              border-radius: 10px;
              display: none;
            }
            
            .custom-scrollbar::-webkit-scrollbar-thumb {
              background: #B03982;
              border-radius: 10px;
              display: none;
            }
            
            .custom-scrollbar.has-content::-webkit-scrollbar-track,
            .custom-scrollbar.has-content::-webkit-scrollbar-thumb {
              display: block;
            }
            
            .custom-scrollbar::-webkit-scrollbar-thumb:hover {
              background: #8c2d66;
            }

            .whitespace-pre-line {
              white-space: pre-line;
            }
            
            .active-rating {
              color: #B03982 !important;
            }
          `}
        </style>
        <div className="w-full flex items-end justify-between">
          {/* Middle Div - Main Chat Area */}
          <div className="p-4 flex flex-col justify-between flex-1 max-w-[80%] ml-36 h-[90vh]">
            {/* Top Section - Chat Messages */}
            <div
              className="flex flex-col gap-4 overflow-y-scroll custom-scrollbar"
              ref={chatContainerRef}
            >
              {/* Header with new session handler */}
              <Header dir={dir} onStartNewSession={handleNewSession} />

              {/* Display session history */}
              <div className="session-list mt-4">
                {latestSession && (
                  <h2 className="text-lg font-bold">{latestSession}</h2>
                )}
              </div>
              {/* Greeting Card */}
              {conversation.length === 0 && (
                <div className="w-full p-4 bg-gray-100 rounded-lg shadow-md">
                  <p className="text-lg font-semibold text-gray-800 mb-2">
                    {t("start_msg")}
                  </p>
                </div>
              )}

              {/* Question and Response Area */}

              <div className="space-y-4">
                {conversation.map((msg) => (
                  <div
                    key={msg.id}
                    className={`flex w-full mb-4 ${msg.sender === "user" ? "justify-end" : "justify-start"}`}
                  >
                    {msg.sender === "user" ? (
                      <div className={`flex items-start gap-4 w-full ${dir === 'rtl' ? 'flex-row-reverse' : ''}`}>
                        {/* Avatar */}
                        <div className="w-12 h-12 flex-shrink-0 cursor-pointer bg-gray-100 rounded-full border-4 border-[#B03982] flex items-center justify-center hover:shadow-lg transition-shadow">
                          <span className="text-black text-[18px] font-semibold">
                            {parsedDataOutScope?.name?.split(" ").map(w => w[0]).slice(0, 2).join("").toUpperCase()}
                          </span>
                        </div>

                        {/* Message / Edit area */}
                        <div className="flex-1 group relative">
                          {editingMessageId === msg.id ? (
                            /* ── Edit mode ── */
                            <div className="flex flex-col gap-2">
                              <textarea
                                autoFocus
                                value={editingText}
                                onChange={(e) => setEditingText(e.target.value)}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); handleSaveEdit(); }
                                  if (e.key === "Escape") handleCancelEdit();
                                }}
                                className="w-full p-3 rounded-lg border-2 border-[#B03982] focus:outline-none resize-none text-gray-900 bg-white shadow-md"
                                rows={3}
                              />
                              <div className="flex gap-2 justify-end">
                                <button
                                  onClick={handleCancelEdit}
                                  className="px-4 py-1.5 text-sm rounded-full border border-gray-400 text-gray-600 hover:bg-gray-100 transition-colors"
                                >
                                  Cancel
                                </button>
                                <button
                                  onClick={handleSaveEdit}
                                  disabled={!editingText.trim() || loading}
                                  className="px-4 py-1.5 text-sm rounded-full bg-[#B03982] text-white hover:bg-[#902F6A] disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
                                >
                                  Send
                                </button>
                              </div>
                            </div>
                          ) : (
                            /* ── Display mode ── */
                            <div className={`relative p-3 rounded-lg shadow-md bg-gray-100 text-gray-900 ${isUrdu(msg.message) || isArabic(msg.message) ? "text-right" : "text-left"}`}>
                              <h3 className="text-base font-semibold break-words whitespace-normal pr-7">
                                {msg.message}
                              </h3>
                              {/* Pencil icon — visible on hover */}
                              {!loading && (
                                <button
                                  onClick={() => handleEditMessage(msg)}
                                  className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity p-1 rounded-md hover:bg-gray-200 text-gray-500 hover:text-[#B03982]"
                                  aria-label="Edit message"
                                >
                                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                  </svg>
                                </button>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div
                        className={`flex items-start w-full text-right gap-2`}
                      >
                        {/* gap-2 AI avatar */}
                        {/* <div className="w-14 h-14 cursor-pointer rounded-full bg-white flex items-center justify-center"> */}
                        <span className="w-12 h-12">
                          <img src={nerdyicon} alt="AI" />
                        </span>
                        {/* </div> */}

                        {/* AI response */}
                        <div
                          className={`flex-1 text-gray-700 break-words whitespace-normal ${isUrdu(msg.message) || isArabic(msg.message) ? "text-right" : "text-left"
                            }`}
                        >
                          <ReactMarkdown
                            className="responseStream_Main"
                            children={msg.message}
                            remarkPlugins={[remarkGfm]}
                            rehypePlugins={[rehypeRaw]}
                            unwrapDisallowed={false}
                          // components={{
                          //   a: ({ node, ...props }) => (
                          //     <a
                          //       {...props}
                          //       target="_blank"
                          //     />
                          //   )
                          // }}
                          />

                          {/* Rating buttons */}
                          {isLastAIResponse(msg) && (
                            <div className={`flex ${dir === 'rtl' ? 'justify-end' : ''} mt-2 space-x-2`}>
                              <button
                                className={`text-gray-400 hover:text-black ml-2 ${msg.ratingGiven === "ThumbsUp" ? "active-rating" : ""}`}
                                onClick={() => handleRating(msg.id, "ThumbsUp")}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <path d="M7 10v12" />
                                  <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a3.13 3.13 0 0 1 3 3.88Z" />
                                </svg>
                              </button>
                              <button
                                className={`text-gray-400 hover:text-black ml-2 ${msg.ratingGiven === "ThumbsDown" ? "active-rating" : ""}`}
                                onClick={() => handleRating(msg.id, "ThumbsDown")}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <path d="M17 14V2" />
                                  <path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22h0a3.13 3.13 0 0 1-3-3.88Z" />
                                </svg>
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
                <div>
                  {loading && (
                    <div className="flex items-center justify-center w-full">
                      <img
                        src={loadingGif}
                        alt={t("loading")}
                        className="w-60"
                      />
                    </div>
                  )}

                  {responseStream && (
                    // <div className="w-full p-4 bg-gray-100 rounded-lg shadow-md">
                    //   <ReactMarkdown
                    //     className="text-gray-700 responseStream_Main"
                    //     children={responseStream}
                    //     remarkPlugins={[remarkGfm]}
                    //     rehypePlugins={[rehypeRaw]}
                    //     unwrapDisallowed={false}
                    //   />
                    // </div>
                    <div className="flex items-start gap-4">
                      <span className="w-12 h-12">
                        <img src={nerdyicon} alt="AI" />
                      </span>
                      <div className="flex-1">
                        <TaxInitialAllowance message={responseStream} />
                      </div>
                    </div>
                  )}
                </div>
              </div>



            </div>
            {/* Bottom Section - Input Area */}
            <div className="relative w-full">
              <ScrollButton helperButton={helperButton} chatContainerRef={chatContainerRef} />
              <div>
                {helperButton && (
                  <div className="flex justify-center gap-10 mb-10 mt-10">
                    {references && references !== "No references found." && (
                      <button
                        onClick={handleNavigateToReferences}
                        disabled={helperLoader}
                        className={`px-4 py-2 border-2 border-[#B03982] rounded-3xl w-[11rem] ${helperLoader
                          ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                          : "bg-transparent text-[#B03982] hover:bg-[#B03982] hover:text-white"
                          }`}
                      >
                        {t("show_refernces")}
                      </button>
                    )}
                    {suggestedQuestions.length > 0 && (
                      <button
                        onClick={handleRefineSuggestions}
                        disabled={helperLoader}
                        className={`px-4 py-2 rounded-3xl w-[11rem] ${helperLoader
                          ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                          : "bg-[#B03982] text-white hover:bg-[#8c2d66]"
                          }`}
                      >
                        {t("refine_it")}
                      </button>
                    )}
                    {documentCount > 1 &&
                      suggestedQuestions.length > 0 &&
                      references &&
                      references !== "No references found." && (
                        <button
                          onClick={handleEditDoc}
                          disabled={helperLoader}
                          className={`px-4 py-2 rounded-3xl w-[11rem] ${helperLoader
                            ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                            : "bg-[#B03982] text-white hover:bg-[#8c2d66]"
                            }`}
                        >
                          {t("select_document")}
                        </button>
                      )}
                  </div>
                )}
              </div>
              <div className="flex items-center border border-gray-300 rounded-lg focus-within:ring-2 focus-within:ring-[#B03982] overflow-hidden min-h-[3.5rem]">
                <textarea
                  value={question}
                  onChange={(e) => setQuestion(e.target.value)}
                  onKeyDown={(e) => {
                    if (
                      e.key === "Enter" &&
                      !e.shiftKey &&
                      question.trim() &&
                      !loading
                    ) {
                      e.preventDefault();
                      handleSend();
                    }
                  }}
                  placeholder={t("ask_buddy")}
                  disabled={loading}
                  className="flex-grow h-full px-4 py-3 focus:outline-none resize-none disabled:cursor-not-allowed placeholder:text-gray-500"
                  rows={1}
                  style={{
                    minHeight: '44px',
                    maxHeight: '120px',
                  }}
                />

                {/* Mic/Record Button */}
                <button
                  onClick={handleClick}
                  disabled={loading}
                  className={`px-2 h-full flex items-center justify-center ${dir === 'rtl' ? 'border-l' : 'border-r'} border-gray-300 disabled:opacity-50 disabled:cursor-not-allowed`}
                  aria-label={listening ? "Stop recording" : "Start recording"}
                >
                  {listening ? (
                    <div className="flex items-center justify-center">
                      <div className="w-8 h-8 rounded-full bg-red-500 flex items-center justify-center animate-pulse">
                        <div className="w-4 h-4 rounded-sm bg-white"></div>
                      </div>
                    </div>
                  ) : (
                    <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
                      <svg className="w-8 h-8 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
                        <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
                      </svg>
                    </div>
                  )}
                </button>

                {/* Action Button (Send/Pause) */}
                <div className="mx-2">
                  {(loading || responseStream) ? (
                    <button
                      onClick={stopStream}
                      disabled={!(loading || responseStream)}
                      className={`h-10 w-10 rounded-lg flex items-center justify-center text-white font-semibold bg-red-500 hover:bg-red-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors`}
                      aria-label="Stop"
                    >
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                        <rect x="6" y="6" width="12" height="12" />
                      </svg>
                    </button>
                  ) : (
                    <button
                      onClick={handleSend}
                      disabled={!question.trim() || loading}
                      className={`h-10 w-10 rounded-lg flex items-center justify-center text-white font-semibold transition-colors ${question.trim() && !loading
                        ? "bg-[#B03982] hover:bg-[#902F6A]"
                        : "bg-gray-300 cursor-not-allowed"
                        }`}
                      aria-label="Send message"
                    >
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
                      </svg>
                    </button>
                  )}
                </div>
              </div>
              <p className="text-gray-500 text-center mt-3">NerdyBuddy can be inaccurate; please double check its responses.</p>
            </div>
          </div>
          {/* Third Div - Character Image */}
          <div className="p-4 pl-8 gap-36 flex flex-col">
            <div className="w-[16rem] h-[20rem]">
              <CharacterDisplay loading={loading} />
              {/* <img src={Character} alt="Character" className="w-full h-full object-cover relative z-[-1]" /> */}
            </div>
          </div>
          <Modal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            type={modalType}
          >
            {modalType === "refine" && (
              <Refine
                suggestedQuestions={suggestedQuestions}
                onSelectOption={handleSelectOption}
                onCloseModal={() => setIsModalOpen(false)}
                refineCount={refineCount}
              />
            )}
            {modalType === "doc" && (
              <Doc
                // documentDetails={documentDetails}
                documentDetails={documentInfo}
                onSelectOption={handleSelectOption}
                onCloseModal={() => setIsModalOpen(false)}
                dir={dir}
              />
            )}
            {modalType === "references" && (
              <References
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                references={references}
                documentInfo={documentInfo}
                dir={dir}
              />
            )}
          </Modal>
        </div>
      </div>
    )
  } else {
    return (
      <div dir={dir} className="min-h-full w-full flex" style={{ height: 'calc(100vh - 90px)' }}>
        <style>
          {`
            .custom-scrollbar::-webkit-scrollbar {
              width: 5px;
            }
            
            .custom-scrollbar::-webkit-scrollbar-track {
              background: #f1f1f1;
              border-radius: 10px;
              display: none;
            }
            
            .custom-scrollbar::-webkit-scrollbar-thumb {
              background: #B03982;
              border-radius: 10px;
              display: none;
            }
            
            .custom-scrollbar.has-content::-webkit-scrollbar-track,
            .custom-scrollbar.has-content::-webkit-scrollbar-thumb {
              display: block;
            }
            
            .custom-scrollbar::-webkit-scrollbar-thumb:hover {
              background: #8c2d66;
            }

            .whitespace-pre-line {
              white-space: pre-line;
            }
            
            .active-rating {
              color: #B03982 !important;
            }
          `}
        </style>
        <div className="w-full flex items-end justify-between">
          {/* First Div - Character Image */}
          <div></div>

          {/* Middle Div - Main Chat Area */}
          <div className="h-screen p-4 flex flex-col justify-between flex-1 max-w-[60%] ml-20">
            {/* Top Section - Chat Messages */}
            <div
              className="flex flex-col gap-4 mt-[3.5rem] h-full overflow-y-scroll custom-scrollbar"
              ref={chatContainerRef}
            >
              {/* Header with new session handler */}
              <Header dir={dir} onStartNewSession={handleNewSession} />

              {/* Display session history */}
              <div className="session-list mt-4">
                {latestSession && (
                  <h2 className="text-lg font-bold">{latestSession}</h2>
                )}
              </div>
              {/* Greeting Card */}
              {conversation.length === 0 && (
                <div className="w-full p-4 bg-gray-100 rounded-lg shadow-md">
                  <p className="text-lg font-semibold text-gray-800 mb-2">
                    {t("start_msg")}
                  </p>
                </div>
              )}

              {/* Question and Response Area */}
              <div className="space-y-4">
                {conversation.map((msg) => (
                  <div
                    key={msg.id}
                    className={`flex w-full mb-4 ${msg.sender === "user" ? "justify-end" : "justify-start"}`}
                  >
                    {msg.sender === "user" ? (
                      <div className={`flex items-start gap-4 w-full ${dir === 'rtl' ? 'flex-row-reverse' : ''}`}>
                        {/* Avatar */}
                        <div className="w-12 h-12 flex-shrink-0 cursor-pointer bg-gray-100 rounded-full border-4 border-[#B03982] flex items-center justify-center hover:shadow-lg transition-shadow">
                          <span className="text-black text-[18px] font-semibold">
                            {parsedDataOutScope?.name?.split(" ").map(w => w[0]).slice(0, 2).join("").toUpperCase()}
                          </span>
                        </div>

                        {/* Message / Edit area */}
                        <div className="flex-1 group relative">
                          {editingMessageId === msg.id ? (
                            /* ── Edit mode ── */
                            <div className="flex flex-col gap-2">
                              <textarea
                                autoFocus
                                value={editingText}
                                onChange={(e) => setEditingText(e.target.value)}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); handleSaveEdit(); }
                                  if (e.key === "Escape") handleCancelEdit();
                                }}
                                className="w-full p-3 rounded-lg border-2 border-[#B03982] focus:outline-none resize-none text-gray-900 bg-white shadow-md"
                                rows={3}
                              />
                              <div className="flex gap-2 justify-end">
                                <button
                                  onClick={handleCancelEdit}
                                  className="px-4 py-1.5 text-sm rounded-full border border-gray-400 text-gray-600 hover:bg-gray-100 transition-colors"
                                >
                                  Cancel
                                </button>
                                <button
                                  onClick={handleSaveEdit}
                                  disabled={!editingText.trim() || loading}
                                  className="px-4 py-1.5 text-sm rounded-full bg-[#B03982] text-white hover:bg-[#902F6A] disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
                                >
                                  Send
                                </button>
                              </div>
                            </div>
                          ) : (
                            /* ── Display mode ── */
                            <div className={`relative p-3 rounded-lg shadow-md bg-gray-100 text-gray-900 ${isUrdu(msg.message) || isArabic(msg.message) ? "text-right" : "text-left"}`}>
                              <h3 className="text-base font-semibold break-words whitespace-normal pr-7">
                                {msg.message}
                              </h3>
                              {/* Pencil icon — visible on hover */}
                              {!loading && (
                                <button
                                  onClick={() => handleEditMessage(msg)}
                                  className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity p-1 rounded-md hover:bg-gray-200 text-gray-500 hover:text-[#B03982]"
                                  aria-label="Edit message"
                                >
                                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                  </svg>
                                </button>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div
                        className={`flex items-start w-full text-right gap-4`}
                      >
                        {/* gap-2 AI avatar */}
                        {/* <div className="w-14 h-14 cursor-pointer rounded-full bg-white flex items-center justify-center"> */}
                        <span className="w-12 h-12">
                          <img src={nerdyicon} alt="AI" />
                        </span>
                        {/* </div> */}

                        {/* AI response */}
                        <div
                          className={`flex-1 text-gray-700 break-words whitespace-normal ${isUrdu(msg.message) || isArabic(msg.message) ? "text-right" : "text-left"
                            }`}
                        >

                          <TaxInitialAllowance message={msg.message} />

                          {/* Rating buttons */}
                          {isLastAIResponse(msg) && (
                            <div className={`flex ${dir === 'rtl' ? 'justify-end' : ''} mt-2 space-x-2`}>
                              <button
                                className={`text-gray-400 hover:text-black ml-2 ${msg.ratingGiven === "ThumbsUp" ? "active-rating" : ""}`}
                                onClick={() => handleRating(msg.id, "ThumbsUp")}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <path d="M7 10v12" />
                                  <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a3.13 3.13 0 0 1 3 3.88Z" />
                                </svg>
                              </button>
                              <button
                                className={`text-gray-400 hover:text-black ml-2 ${msg.ratingGiven === "ThumbsDown" ? "active-rating" : ""}`}
                                onClick={() => handleRating(msg.id, "ThumbsDown")}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <path d="M17 14V2" />
                                  <path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22h0a3.13 3.13 0 0 1-3-3.88Z" />
                                </svg>
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
                <div>
                  {loading && (
                    <div className="flex items-center justify-center w-full">
                      <img
                        src={loadingGif}
                        alt={t("loading")}
                        className="w-60"
                      />
                    </div>
                  )}

                  {responseStream && (
                    // <div className="w-full p-4 bg-gray-100 rounded-lg shadow-md">
                    //   <ReactMarkdown
                    //     className="text-gray-700 responseStream_Main"
                    //     children={responseStream}
                    //     remarkPlugins={[remarkGfm]}
                    //     rehypePlugins={[rehypeRaw]}
                    //     unwrapDisallowed={false}
                    //   />
                    // </div>
                    <div className="flex items-start gap-4">
                      <span className="w-12 h-12">
                        <img src={nerdyicon} alt="AI" />
                      </span>
                      <div className="flex-1">
                        <TaxInitialAllowance message={responseStream} />
                      </div>
                    </div>
                  )}
                </div>
              </div>

            </div>
            {/* Bottom Section - Input Area */}
            <div className="relative w-full ">
              <ScrollButton helperButton={helperButton} chatContainerRef={chatContainerRef} />
              {helperButton && (
                <div className="flex justify-center gap-4 mb-4 mt-4">
                  {references && references !== "No references found." && (
                    <button
                      onClick={handleNavigateToReferences}
                      disabled={helperLoader}
                      className={`px-4 py-2 border-2 border-[#B03982] rounded-full text-sm min-w-[110px] ${helperLoader
                        ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                        : "bg-transparent text-[#B03982] hover:bg-[#B03982] hover:text-white"
                        }`}
                    >
                      {t("show_refernces")}
                    </button>
                  )}

                  {suggestedQuestions.length > 0 && (
                    <button
                      onClick={handleRefineSuggestions}
                      disabled={helperLoader}
                      className={`px-4 py-2 rounded-full text-sm min-w-[110px] ${helperLoader
                        ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                        : "bg-[#B03982] text-white hover:bg-[#8c2d66]"
                        }`}
                    >
                      {t("refine_it")}
                    </button>
                  )}

                  {documentCount > 1 &&
                    suggestedQuestions.length > 0 &&
                    references &&
                    references !== "No references found." && (
                      <button
                        onClick={handleEditDoc}
                        disabled={helperLoader}
                        className={`px-4 py-2 rounded-full text-sm min-w-[110px] ${helperLoader
                          ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                          : "bg-[#B03982] text-white hover:bg-[#8c2d66]"
                          }`}
                      >
                        {t("select_document")}
                      </button>
                    )}
                </div>
              )}
              <div className="flex items-center border border-gray-300 rounded-lg focus-within:ring-2 focus-within:ring-[#B03982] overflow-hidden min-h-[3.5rem]">
                <textarea
                  value={question}
                  onChange={(e) => setQuestion(e.target.value)}
                  onKeyDown={(e) => {
                    if (
                      e.key === "Enter" &&
                      !e.shiftKey &&
                      question.trim() &&
                      !loading
                    ) {
                      e.preventDefault();
                      handleSend();
                    }
                  }}
                  placeholder={t("ask_buddy")}
                  disabled={loading}
                  className="flex-grow h-full px-4 py-3 focus:outline-none resize-none disabled:cursor-not-allowed placeholder:text-gray-500"
                  rows={1}
                  style={{
                    minHeight: '44px',
                    maxHeight: '120px',
                  }}
                />

                {/* Mic/Record Button */}
                <button
                  onClick={handleClick}
                  disabled={loading}
                  className={`px-2 h-full flex items-center justify-center ${dir === 'rtl' ? 'border-l' : 'border-r'} border-gray-300 disabled:opacity-50 disabled:cursor-not-allowed`}
                  aria-label={listening ? "Stop recording" : "Start recording"}
                >
                  {listening ? (
                    <div className="flex items-center justify-center">
                      <div className="w-8 h-8 rounded-full bg-red-500 flex items-center justify-center animate-pulse">
                        <div className="w-4 h-4 rounded-sm bg-white"></div>
                      </div>
                    </div>
                  ) : (
                    <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
                      <svg className="w-8 h-8 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
                        <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
                      </svg>
                    </div>
                  )}
                </button>

                {/* Action Button (Send/Pause) */}
                <div className="mx-2">
                  {(loading || responseStream) ? (
                    <button
                      onClick={stopStream}
                      disabled={!(loading || responseStream)}
                      className={`h-10 w-10 rounded-lg flex items-center justify-center text-white font-semibold bg-red-500 hover:bg-red-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors`}
                      aria-label="Stop"
                    >
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                        <rect x="6" y="6" width="12" height="12" />
                      </svg>
                    </button>
                  ) : (
                    <button
                      onClick={handleSend}
                      disabled={!question.trim() || loading}
                      className={`h-10 w-10 rounded-lg flex items-center justify-center text-white font-semibold transition-colors ${question.trim() && !loading
                        ? "bg-[#B03982] hover:bg-[#902F6A]"
                        : "bg-gray-300 cursor-not-allowed"
                        }`}
                      aria-label="Send message"
                    >
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
                      </svg>
                    </button>
                  )}
                </div>
              </div>
              <p className="text-gray-500 text-center mt-2">NerdyBuddy can be inaccurate; please double check its responses.</p>
            </div>
          </div>

          {/* Third Div - Character Image */}
          <div className="p-4 pl-8 gap-36 flex flex-col">
            <div className="w-[20rem] h-[26rem]">
              <CharacterDisplay loading={loading} />
              {/* <img src={Character} alt="Character" className="w-full h-full object-cover relative z-[-1]" /> */}
            </div>
          </div>
          <Modal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            type={modalType}
          >
            {modalType === "refine" && (
              <Refine
                suggestedQuestions={suggestedQuestions}
                onSelectOption={handleSelectOption}
                onCloseModal={() => setIsModalOpen(false)}
                refineCount={refineCount}
              />
            )}
            {modalType === "doc" && (
              <Doc
                // documentDetails={documentDetails}
                documentDetails={documentInfo}
                onSelectOption={handleSelectOption}
                onCloseModal={() => setIsModalOpen(false)}
                dir={dir}
              />
            )}
            {modalType === "references" && (
              <References
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                references={references}
                documentInfo={documentInfo}
                dir={dir}
              />
            )}
          </Modal>
        </div>
        {/* <Recording /> */}
        {/* <LiveChat /> */}
      </div>
    );
  }

};

export default Home;